export const translations = {
  en: {
    "app.name": "BoxPrep",
    "nav.dashboard": "Overview",
    "nav.sender_warehouse": "Sender Warehouse",
    "nav.planning": "Planning",
    "nav.receiver_warehouse": "Receiver Warehouse",
    "nav.marketplace_amazon_fba": "Amazon FBA",
    "nav.admin": "Management",
    "nav.logout": "Logout",
    "whatsnew.button": "What's new",
    "whatsnew.title": "What's new",
    "whatsnew.empty": "No release notes yet.",
    "whatsnew.new": "New",
    "login.subtitle": "Warehouse Management System",
    "login.sign_in": "Sign In",
    "login.signing_in": "Signing in...",
    "login.email": "Email",
    "login.password": "Password",
    "login.invalid": "Invalid email or password",
    "nav.management": "Management",
    "role.platform_admin": "Platform Admin",
    "role.tenant_admin": "Tenant Admin",
    "role.tenant_member": "Tenant Member",
    "role.warehouse_staff": "Warehouse Staff",
    "adm.error": "Something went wrong",
    "adm.optional": "optional",
    "adm.deleted": "Deleted",
    "adm.delete_title": "Delete \"{{name}}\"?",
    "adm.delete_warning": "This action cannot be undone.",
    "adm.pr.new": "New Product",
    "adm.pr.name": "Product Name",
    "adm.pr.search": "Global search (ASIN / name / EAN)...",
    "adm.pr.empty": "No products found.",
    "adm.pr.created": "Product created",
    "adm.pr.deleted": "Product deleted",
    "adm.pr.duplicate": "This ASIN already exists in the catalog. The existing product was not changed.",
    "adm.pr.csv_hint": "File columns: ASIN, PRODUCT_NAME, EAN (optional), CATEGORY (optional). Existing ASINs are never overwritten.",
    "adm.st.new": "New Store",
    "adm.st.name": "Store Name",
    "adm.st.empty": "No stores yet.",
    "adm.st.created": "Store created",
    "adm.st.deleted": "Store deleted",
    "adm.fn.add": "Add FNSKU",
    "adm.fn.code": "FNSKU Code",
    "adm.fn.select_store": "Select store...",
    "adm.fn.saved": "FNSKU saved",
    "adm.fn.empty": "No FNSKUs yet. Import a file with ASIN, STORE_NAME, FNSKU.",
    "adm.fn.csv_hint": "File columns: ASIN, STORE_NAME, FNSKU. Missing stores are created for your tenant.",
    "adm.capped_search": "Only the first {{count}} records are shown. Use the search box to find the others.",
    "adm.capped": "Only the first {{count}} records are shown; the others are not listed.",
    "adm.us.deleted": "User deleted",
    "adm.import.button": "Import file",
    "adm.import.title": "Import result",
    "adm.import.failed": "Import failed",
    "adm.import.imported": "{{count}} rows imported",
    "adm.import.duplicates": "{{count}} rows skipped: ASIN already exists",
    "adm.import.duplicates_hint": "Existing catalog products are never overwritten.",
    "adm.import.errors": "{{count}} rows rejected",
    "adm.import.more": "and {{count}} more rows",
    "adm.import.row": "Row {{row}}",
    "adm.import.reason.missing_asin": "ASIN is missing",
    "adm.import.reason.missing_product_name": "Product name is missing",
    "adm.import.reason.missing_value": "ASIN, store name or FNSKU is missing",
    "adm.import.reason.unknown_asin": "ASIN is not in your product list",
    "adm.import.reason.invalid_asin": "ASIN is missing or too long",
    "adm.import.reason.invalid_quantity": "QTY must be a whole number of 1 or more",
    "adm.import.reason.invalid_order_id": "ORDER_ID is missing or too long",
    "adm.code": "Code",
    "adm.tn.id": "ID",
    "adm.tn.copy_id": "Copy tenant ID",
    "adm.tn.id_copied": "Tenant ID copied",
    "adm.country": "Country",
    "adm.active": "Active",
    "adm.inactive": "Inactive",
    "adm.suspended": "Suspended",
    "adm.suspend": "Suspend",
    "adm.activate": "Activate",
    "adm.deactivate": "Deactivate",
    "adm.tab.tenants": "Tenants",
    "adm.tab.warehouses": "Warehouses",
    "adm.tab.users": "Users",
    "adm.tab.route": "Route",
    "adm.tab.products": "Product Catalog",
    "adm.tab.stores": "Stores",
    "adm.tab.fnsku": "Store FNSKU",
    "adm.tab.testdata": "Test Data",
    "adm.tab.dbbackup": "DB Backup",
    "adm.tab.settings": "Settings",
    "adm.tab.inbound": "Inbound",
    "adm.tr.title": "Run backend tests",
    "adm.tr.intro": "Runs the whole backend test suite on this server. It creates and removes test data in the database and takes a few minutes. Available in the development/test environment only.",
    "adm.tr.start": "Run tests",
    "adm.tr.clear": "Clear result",
    "adm.tr.running": "Running...",
    "adm.tr.passed": "Passed",
    "adm.tr.failed": "Failed",
    "adm.tr.already": "A test run is already in progress",
    "adm.td.title": "Remove test data",
    "adm.td.intro": "Finds and removes data that carries the test naming below, together with everything that belongs to it (pallets, boxes, labels, notifications). Real data is not matched.",
    "adm.td.rule_tenant": "Tenant code starts with",
    "adm.td.rule_warehouse": "Warehouse code starts with",
    "adm.td.rule_email": "User e-mail",
    "adm.td.rule_asin": "Product ASIN starts with",
    "adm.td.scan": "Scan again",
    "adm.td.delete": "Delete test data",
    "adm.td.empty": "No test data found.",
    "adm.td.total": "Total records",
    "adm.td.files_note": "{{n}} uploaded files: files on R2 storage are deleted for real. Files on the old Emergent storage cannot be deleted and stay there; only their records are removed.",
    "adm.td.confirm_title": "Delete {{n}} test records?",
    "adm.td.confirm_body": "This cannot be undone. Only records matching the test naming are deleted.",
    "adm.td.done": "{{n}} test records deleted",
    "adm.td.changed": "The data changed since the scan. Scan again and retry.",
    "adm.td.seed": "Load test data",
    "adm.td.seeded": "Test data loaded ({{n}} users)",
    "adm.td.seed_result": "Password for every account: {{password}}",
    "adm.td.seed_counts": "{{tenants}} tenants, {{warehouses}} warehouses, {{users}} users, {{products}} products, {{stores}} stores, {{fnsku}} FNSKU mappings",
    "adm.cap.SENDER": "Sender",
    "adm.cap.RECEIVER": "Receiver",
    "adm.marketplace.AMAZON_FBA": "Amazon FBA",
    "adm.wh.new": "New Warehouse",
    "adm.wh.edit": "Edit Warehouse",
    "adm.wh.empty": "No warehouses yet.",
    "adm.wh.capabilities": "Capabilities",
    "adm.wh.address": "Address",
    "adm.wh.contact_person": "Contact person",
    "adm.wh.phone": "Contact phone",
    "adm.wh.email": "Contact email",
    "adm.wh.created": "Warehouse created",
    "adm.wh.updated": "Warehouse updated",
    "adm.wh.activated": "Warehouse activated",
    "adm.wh.deactivated": "Warehouse deactivated",
    "adm.tn.new": "New Tenant",
    "adm.tn.edit": "Edit Tenant",
    "adm.tn.empty": "No tenants yet.",
    "adm.tn.open": "Open routes and administrators",
    "adm.tn.multi_profile": "Allow multiple active route profiles",
    "adm.tn.inbound": "Inbound and Stock",
    "adm.tn.inbound_hint": "Off: the tenant and the sender warehouse staff do not see its Inbound and Stock, and pallets are not checked against stock. Saved data is kept.",
    "adm.tn.marketplaces": "Purchased marketplaces",
    "adm.tn.marketplaces_hint": "The tenant's administrators can use these marketplaces and hand them to members. Nothing is enabled automatically.",
    "adm.cap.title": "Permissions",
    "adm.cap.PLANNING": "Planning",
    "adm.cap.marketplace": "Marketplace",
    "adm.cap.locked": "Administrators hold every permission their tenant has. Only the platform administrator can change this.",
    "adm.tn.add_admin": "Add tenant administrator",
    "adm.tn.admin_created": "Tenant administrator created",
    "adm.tn.admins": "Tenant administrators",
    "adm.tn.no_admins": "No administrator yet.",
    "adm.tn.last_admin_warning": "This is the last administrator of this tenant. Without one, nobody in the tenant can manage users, stores or products until you add a new administrator.",
    "adm.us.tenant": "Tenant",
    "adm.us.reset_password": "Reset password",
    "adm.us.new_password": "New password",
    "adm.us.password_reset": "Password was reset",
    "adm.us.password_min": "At least 12 characters.",
    "adm.us.reset_hint": "The administrator's current sessions end and they must sign in with the new password.",
    "adm.tn.created": "Tenant created",
    "adm.tn.updated": "Tenant updated",
    "adm.tn.status_changed": "Tenant status changed",
    "adm.rp.title": "Route profiles",
    "adm.rp.new": "New Route Profile",
    "adm.rp.edit": "Edit Route Profile",
    "adm.rp.empty": "No route profiles yet.",
    "adm.rp.source": "Source warehouse",
    "adm.rp.destination": "Destination warehouse",
    "adm.rp.marketplace": "Marketplace",
    "adm.rp.versions": "Versions",
    "adm.rp.select_warehouse": "Select warehouse...",
    "adm.rp.created": "Route profile created",
    "adm.rp.updated": "Route profile updated",
    "adm.rp.status_changed": "Route profile status changed",
    "adm.us.edit": "Edit User",
    "adm.us.created": "User created",
    "adm.us.updated": "User updated",
    "adm.us.keep_password": "leave blank to keep",
    "adm.us.warehouses_title": "Warehouse assignments",
    "adm.us.warehouses_saved": "Warehouse assignments saved",
    "adm.nt.title": "Notifications",
    "adm.nt.empty": "No notifications.",
    "adm.nt.mark_read": "Mark as read",
    "adm.nt.ROUTE_PROFILE_CREATED": "Route profile {{code}} was created.",
    "adm.nt.ROUTE_PROFILE_UPDATED": "Route profile {{code}} was updated (version {{version}}).",
    "adm.nt.ROUTE_PROFILE_ACTIVATED": "Route profile {{code}} was activated.",
    "adm.nt.ROUTE_PROFILE_DEACTIVATED": "Route profile {{code}} was deactivated.",
    "common.cancel": "Cancel",
    "common.refresh": "Refresh",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.create": "Create",
    "common.transfer": "Transfer",
    "common.search": "Search...",
    "common.loading": "Loading...",
    "common.confirm": "Confirm",
    "common.back": "Back",
    "common.add": "Add",
    "common.close": "Close",
    "common.upload": "Upload",
    "common.import": "Import",
    "common.name": "Name",
    "common.quantity": "Quantity",
    "common.status": "Status",
    "common.actions": "Actions",
    "common.notes": "Notes",
    "common.date": "Date",
    "common.all": "All",
    "common.filter": "Filter",
    "common.yes": "Yes",
    "common.no": "No",
    "common.submit": "Submit",
    "common.scan": "Scan",
    "common.filterPlaceholder": "Filter…",
    "scanner.cameraStalled": "Camera preview stalled. Please allow camera access or check your device.",
    "scanner.cameraUnavailable": "Camera not available. Please allow camera access or check your device.",
    "scanner.starting": "Starting camera...",
    "scanner.scanning": "Scanning... point at barcode / QR",
    "scanner.title": "Scan Barcode / ASIN",
    "scanner.hideManual": "Hide manual entry",
    "scanner.enterManually": "Enter manually",
    "scanner.manualPlaceholder": "ASIN / FNSKU / EAN...",
    "scanner.ok": "OK",
    "common.asin": "ASIN",
    "common.product": "Product",
    "common.store": "Store",
    "common.box": "Box",
    "common.pallet": "Pallet",
    "common.items": "Items",
    "common.boxes": "Boxes",
    "us.create_pallet": "Create Pallet",
    "us.pallet_name": "Pallet Name",
    "us.add_item": "Add Item",
    "us.show_transferred": "Show Transferred",
    "us.show_active": "Show Active",
    "us.scan_or_search": "Scan or Search Product",
    "us.route": "Route",
    "us.select_route": "Select route...",
    "us.tenant": "Tenant",
    "us.select_tenant": "Select tenant...",
    "us.no_routes": "No route is configured for your warehouse.",
    "us.mark_ready": "Mark Ready",
    "us.start_shipment": "Start Shipment",
    "us.ready_title": "Mark pallet ready?",
    "us.ready_body": "Items can no longer change. Tenants can start planning right away.",
    "us.ship_title": "Start shipment?",
    "us.ship_body": "Confirm that the pallet has left the warehouse. The route and contents can no longer change.",
    "us.final_notice": "The contents are final. Tenants can plan their items. Start the shipment when the pallet leaves.",
    "us.shipped_notice": "The pallet is in transit. The contents can no longer change.",
    "us.received_notice": "The pallet was received at the destination warehouse.",
    "us.work.PLANNING": "Planning",
    "us.work.SUBMITTED": "Sent to warehouse",
    "us.work.BOXING": "Boxing",
    "us.work.BOXED": "Boxed",
    "us.tenant_summary": "{{count}} types · {{units}} units",
    "us.msg.added": "{{name}} added ({{qty}} units)",
    "us.msg.over_stock": "Added, but there is not enough of this product on the shelf (On shelf: {{n}}). The inbound records may be missing a delivery.",
    "us.msg.removed": "Item removed",
    "us.msg.created": "Pallet created",
    "us.msg.deleted": "Pallet deleted",
    "us.msg.ready": "Pallet marked ready",
    "us.msg.shipped": "Shipment started",
    "us.search_placeholder": "Search by ASIN, EAN or product name...",
    "us.no_approved_match": "No product found in this tenant's approved list. The tenant must add it to its own product list first.",
    "us.no_items": "No items yet. Add products to this pallet.",
    "us.no_pallets": "No pallets found",
    "us.no_pallets_hint": "Create your first pallet to get started",
    "us.pallet_name_placeholder": "Pallet name...",
    "us.notes_placeholder": "Optional notes...",
    "us.types": "{{count}} types",
    "us.units": "{{count}} units",
    "us.filter_active": "Active",
    "us.filter_history": "History",
    "us.creating": "Creating...",
    "us.remove_item": "Remove item?",
    "us.remove": "Remove",
    "us.delete_pallet": "Delete pallet?",
    "status.DRAFT": "Preparing",
    "status.READY": "Ready",
    "status.IN_TRANSIT": "In transit",
    "status.RECEIVED": "Received",
    "status.PLANNING": "Planning",
    "status.SUBMITTED": "Sent to receiver",
    "status.BOXING": "Boxing",
    "status.BOXED": "Boxed",
    "dash.subtitle": "Operations center",
    "dash.load_error": "Could not load the overview.",
    "dash.work_title": "Work status",
    "dash.physical_title": "Physical pallets",
    "dash.physical_hint": "Pallet movement at your warehouses, separate from tenant work.",
    "dash.attention_title": "Needs attention",
    "dash.attention_hint": "Open items that need a quick follow-up",
    "dash.attention.open_discrepancies": "Open receiving differences",
    "dash.attention.open_revisions": "Open correction requests",
    "dash.attention.unlabeled_ready_boxes": "Ready boxes without labels",
    "dash.attention.stalled_work": "No change for 7+ days",
    "dash.cycle_title": "Cycle times",
    "dash.cycle.ship_to_receive_hours": "Shipped to received",
    "dash.cycle.queue_to_boxing_hours": "Queue to boxing start",
    "dash.cycle.boxing_hours": "Boxing",
    "dash.cycle.labelling_hours": "Boxed to labelled",
    "dash.avg_hours": "avg hours",
    "dash.activity_title": "Recent activity",
    "dash.activity_empty": "No activity yet",
    "dash.system": "System",
    "dash.event.PALLET_CREATED": "Pallet created",
    "dash.event.PALLET_MARKED_READY": "Pallet marked ready",
    "dash.event.PALLET_SHIPPED": "Pallet shipped",
    "dash.event.PALLET_RECEIVED": "Pallet received",
    "dash.event.PLANNING_SUBMITTED": "Planning sent to receiver",
    "dash.event.PLANNING_REOPENED": "Planning reopened",
    "dash.event.DISTRIBUTION_CREATED": "Distribution created",
    "dash.event.DISTRIBUTION_UPDATED": "Distribution updated",
    "dash.event.BOX_CREATED": "Box created",
    "dash.event.BOX_UPDATED": "Box updated",
    "dash.event.BOX_DELETED": "Box deleted",
    "dash.event.BOX_READY": "Box marked ready",
    "dash.event.BOX_REOPENED": "Box reopened",
    "dash.event.BOXING_COMPLETED": "Boxing completed",
    "dash.event.WORK_RETURNED_TO_PLANNING": "Returned to planning",
    "dash.event.DISCREPANCY_RECORDED": "Receiving difference recorded",
    "dash.event.DISCREPANCY_ACKNOWLEDGED": "Receiving difference acknowledged",
    "dash.event.DAMAGE_REPORTED": "Damage reported",
    "dash.event.BOX_ITEM_OVER_PLAN": "Boxed more than planned",
    "dash.event.INBOUND_ITEM_CREATED": "Inbound row added",
    "dash.event.INBOUND_ITEM_UPDATED": "Inbound order quantity changed",
    "dash.event.INBOUND_ITEM_DELETED": "Inbound row deleted",
    "dash.event.INBOUND_ITEM_CLOSED": "Inbound row closed short",
    "dash.event.INBOUND_RECEIVED": "Goods received at sender warehouse",
    "dash.event.INBOUND_UNANNOUNCED": "Unannounced goods recorded",
    "dash.event.INBOUND_OWNER_ASSIGNED": "Owner assigned to goods",
    "dash.event.INBOUND_DAMAGE_ACKNOWLEDGED": "Inbound damage acknowledged",
    "dash.event.INBOUND_PHOTO_ADDED": "Inbound photo added",
    "dash.event.WORK_REVISION_REQUESTED": "Correction requested",
    "dash.event.WORK_REVISION_RESOLVED": "Correction resolved",
    "dash.event.WORK_ITEM_ADDED": "Pallet item added by tenant",
    "dash.event.WORK_ITEM_UPDATED": "Pallet item quantity changed by tenant",
    "dash.event.WORK_ITEM_REMOVED": "Pallet item removed by tenant",
    "dash.event.LABEL_UPLOADED": "Label uploaded",
    "dash.event.LABEL_DELETED": "Label deleted",
    "dash.event.LABELS_PRINTED": "Labels printed",
    "dash.event.BOX_LABELS_APPLIED": "Labels applied",
    "dash.event.BOX_LABELS_UNAPPLIED": "Labels unmarked",
    "dash.event.MARKETPLACE_COMPLETED": "Marketplace step completed",
    "planning.back": "Back to planning list",
    "planning.active": "Active",
    "planning.history": "History",
    "planning.empty_title": "No planning work here",
    "planning.empty_active": "New work appears after items are added to a routed pallet.",
    "planning.empty_history": "Completed and submitted work will appear here.",
    "planning.loading_error": "Could not load planning work.",
    "planning.detail_error": "Could not load this planning work.",
    "planning.read_only": "This work has been submitted. Distribution changes are locked.",
    "planning.platform_read_only": "Platform view is read-only.",
    "planning.arrival": "Physical pallet",
    "planning.items": "{{count}} item types",
    "planning.units": "{{count}} units",
    "planning.tenant": "Tenant",
    "planning.all_tenants": "All tenants",
    "planning.distributed": "Fully distributed",
    "planning.remaining": "{{count}} remaining",
    "planning.add_store": "Add store",
    "planning.revise_tip": "Revise quantity",
    "planning.revise_note": "Short note (optional)",
    "planning.revise_save": "Save",
    "planning.revise_done": "Quantity revised",
    "planning.revised": "Revised",
    "planning.revised_was": "Revised (was {{count}})",
    "planning.boxed_note": "The warehouse has already boxed {{count}}. You cannot go below that.",
    "planning.add_store_more": "Add another store",
    "planning.progress": "Store allocation",
    "planning.modal_title": "Allocate: {{name}}",
    "planning.no_fnsku": "No FNSKU mapping exists for this product.",
    "planning.add_fnsku_hint": "Add an FNSKU mapping in Management before allocating this product.",
    "planning.all_stores_used": "Every store with an FNSKU for this product already has an allocation on this pallet.",
    "planning.select_store": "Select store",
    "planning.loading_stores": "Loading stores...",
    "planning.quantity": "Quantity",
    "planning.set_max": "Use remaining quantity",
    "planning.add": "Add allocation",
    "planning.save": "Save",
    "planning.cancel": "Cancel",
    "planning.delete_allocation": "Remove allocation",
    "planning.submit": "Send to receiver queue",
    "planning.submit_title": "Send planning to receiver queue?",
    "planning.submit_body": "Only this tenant's work will be sent. The physical pallet will not move.",
    "planning.submit_success": "Planning sent to receiver queue.",
    "planning.submit_error": "Could not submit planning.",
    "planning.submit_blocked": "Allocate every unit before submitting.",
    "planning.revision_open": "Correction request",
    "planning.items_title": "Pallet items (correction)",
    "planning.items_hint": "Fix what was packed wrongly: change a quantity, remove a product or add the right one. Then correct the distribution and resolve the request.",
    "planning.item_search": "Search ASIN or product name",
    "planning.item_add": "Add",
    "planning.item_added": "Product added.",
    "planning.item_remove": "Remove item",
    "planning.item_removed": "Item removed.",    "planning.revision_status.open": "Open",
    "planning.revision_status.resolved": "Resolved",
    "planning.resolve_revision": "Resolve request",
    "planning.revision_resolved": "Correction request resolved.",
    "planning.revision_history": "Correction history ({{count}})",
    "planning.no_revisions": "No correction requests.",
    "planning.quantity_updated": "Allocation updated.",
    "planning.quantity_added": "Allocation added.",
    "planning.quantity_removed": "Allocation removed.",
    "planning.error": "Something went wrong. Please try again.",
    "notification.many": "{{count}} new notifications",
    "notification.open": "Open",
    "notification.center": "Notifications",
    "notification.empty": "No notifications yet.",
    "notification.mark_all_read": "Mark all as read",
    "notification.type.unknown": "You have a new notification.",
    "notification.type.WORK_REVISION_REQUESTED": "A correction was requested on your planning.",
    "notification.type.BOX_READY": "Box {{box_name}} is ready for labelling.",
    "notification.type.RECEIVING_DISCREPANCY": "The received pallet differs from your declaration. Review and acknowledge it.",
    "notification.type.DAMAGE_REPORTED": "Damage was reported while boxing your items. Review and acknowledge it.",
    "notification.type.BOX_OVER_PLAN": "The warehouse boxed {{boxed}} of {{product_name}} for {{store_name}}, {{over}} more than the {{planned}} you planned.",
    "notification.type.INBOUND_DAMAGED": "{{damaged}} damaged unit(s) of {{asin}} arrived at the sender warehouse. See the photos and mark them as seen.",
    "notification.type.INBOUND_UNANNOUNCED": "The sender warehouse recorded {{quantity}} unit(s) of {{asin}} for you that had no inbound row.",
    "inb.tab.pallets": "Pallets",
    "inb.tab.inbound": "Inbound",
    "inb.tab.stock": "Stock",
    "inb.filter.open": "Open",
    "inb.filter.done": "Completed",
    "inb.filter.unknown": "Owner unknown",
    "inb.state.ORDERED": "Waiting",
    "inb.state.PARTIAL": "Partly arrived",
    "inb.state.COMPLETE": "Completed",
    "inb.state.CLOSED_SHORT": "Closed short",
    "inb.state.UNANNOUNCED": "Unannounced",
    "inb.state.OWNER_UNKNOWN": "Owner unknown",
    "inb.empty.open": "No goods are expected.",
    "inb.empty.done": "No completed rows yet.",
    "inb.empty.unknown": "No goods with an unknown owner.",
    "inb.error": "Something went wrong. Please try again.",
    "inb.no_warehouse": "No sender warehouse is linked to you yet.",
    "inb.add": "Add row",
    "inb.import_hint": "Excel or CSV with the columns ASIN, QTY, ORDER_ID. Rows go to the selected warehouse.",
    "inb.import_duplicates": "{{count}} rows skipped: this ASIN and order ID are already here",
    "inb.import_duplicates_hint": "Uploading the same file again does not add rows twice.",
    "inb.add_hint": "Tell the warehouse about an Amazon order. The warehouse receives it when the goods arrive.",
    "inb.edit_quantity": "Change ordered quantity",
    "inb.product_approved": "Product (approved products only)",
    "inb.unknown_product": "Name not known",
    "inb.order_id": "Order ID",
    "inb.order_id_optional": "Order ID (if known)",
    "inb.ordered": "Ordered",
    "inb.received": "Received",
    "inb.remaining": "Waiting",
    "inb.receive": "Receive",
    "inb.receive_summary": "Ordered {{ordered}} · Received before {{received}} · Waiting {{remaining}}",
    "inb.received_now": "Quantity arrived",
    "inb.damaged_toggle": "Some are damaged",
    "inb.damaged_of_total": "How many of these are damaged?",
    "inb.damage_note_placeholder": "e.g. box crushed, 2 cables broken",
    "inb.photos": "Photos (max 5)",
    "inb.photo_remove": "Remove photo",
    "inb.photos_failed": "Saved, but a photo could not be uploaded. Add it again from the deliveries list.",
    "inb.preview": "{{count}} arrived",
    "inb.preview_split": "{{count}} arrived ({{good}} good, {{damaged}} damaged)",
    "inb.preview_left": "{{count}} still waiting",
    "inb.preview_complete": "everything arrived, the row is completed",
    "inb.preview_over": "{{count}} more than ordered, it is saved anyway",
    "inb.quantity_required": "Enter a whole number of 1 or more.",
    "inb.damaged_required": "Enter the damaged quantity (or untick the box).",
    "inb.damaged_too_many": "Damaged cannot be more than the quantity arrived.",
    "inb.asin_required": "Enter the ASIN.",
    "inb.order_id_required": "Enter the Amazon order ID.",
    "inb.tenant_required": "Choose the tenant or tick \"Owner unknown\".",
    "inb.unannounced": "Unannounced goods",
    "inb.unannounced_hint": "Goods arrived without a row. Choose the owner from the address or company on the parcel.",
    "inb.unannounced_note_placeholder": "e.g. parcel label, tracking number",
    "inb.select_tenant": "Choose tenant",
    "inb.owner_unknown": "Owner unknown",
    "inb.owner_unknown_hint": "Goes into nobody's stock. A photo of the parcel label helps to find the owner.",
    "inb.not_in_list_hint": "Not in this tenant's product list. It is saved anyway and the tenant is told.",
    "inb.not_in_list": "Not in product list",
    "inb.not_in_list_title": "Cannot go on a pallet until the tenant adds the product to its list",
    "inb.assign": "Assign owner",
    "inb.assigned": "Owner assigned.",
    "inb.close_short": "Close short",
    "inb.close_short_body": "{{count}} unit(s) are not expected any more. The row moves to Completed and leaves \"On the way\".",
    "inb.closed": "Row closed short.",
    "inb.deleted": "Row deleted.",
    "inb.added": "Row added. The warehouse now expects these goods.",
    "inb.updated": "Ordered quantity changed.",
    "inb.saved": "Saved.",
    "inb.saved_damaged": "Saved. The tenant was told about the damage.",
    "inb.receipts": "Deliveries",
    "inb.receipts_count": "Deliveries ({{count}})",
    "inb.units": "{{count}} unit(s)",
    "inb.damaged": "Damaged",
    "inb.damaged_count": "{{count}} damaged",
    "inb.seen": "seen",
    "inb.acknowledge": "Mark as seen",
    "inb.acknowledged": "Damage marked as seen.",
    "inb.on_hand": "In warehouse",
    "inb.on_pallet": "On pallet",
    "inb.on_shelf": "On shelf",
    "inb.on_the_way": "On the way",
    "inb.stock_legend": "In warehouse = good units received − shipped pallets. On pallet = on pallets not shipped yet. On shelf = waiting on the shelf, free for a new pallet. Damaged units never count as on the shelf.",
    "inb.stock_empty": "No stock yet. Stock starts with your first inbound row at this warehouse.",
    "inb.stock_search": "Search by ASIN or product name...",
    "inb.inbound_search": "Search by ASIN, product name or order ID...",
    "inb.search_no_match": "Nothing matches your search or filter.",
    "inb.group_by_order": "Group by order",
    "inb.no_order_id": "No order ID",
    "inb.group_summary": "{{count}} rows · {{remaining}} still to come",
    "notification.type.ROUTE_PROFILE_CREATED": "Route profile {{code}} was created.",
    "notification.type.ROUTE_PROFILE_UPDATED": "Route profile {{code}} was updated (version {{version}}).",
    "notification.type.ROUTE_PROFILE_ACTIVATED": "Route profile {{code}} was activated.",
    "notification.type.ROUTE_PROFILE_DEACTIVATED": "Route profile {{code}} was deactivated.",
    "notification.type.PALLET_READY": "Pallet {{pallet_name}} is ready. You can start planning.",
    "notification.type.PALLET_SHIPPED": "Pallet {{pallet_name}} was shipped to the destination warehouse.",
    "notification.type.PALLET_INCOMING": "Pallet {{pallet_name}} is on its way to your warehouse.",
    "notification.type.PLANNING_SUBMITTED": "{{tenant_name}} sent its plan for pallet {{pallet_name}}.",
    "notification.type.PALLET_RECEIVED": "Pallet {{pallet_name}} was received at the destination warehouse. The counts match your declaration.",
    "notification.type.REVISION_RESOLVED": "{{tenant_name}} resolved your correction request on pallet {{pallet_name}}.",
    "uk.create_box": "Create Box",
    "uk.box_name": "Box Name",
    "uk.weight": "Weight (kg)",
    "uk.dimensions": "Dimensions (cm)",
    "uk.length": "Length",
    "uk.width": "Width",
    "uk.height": "Height",
    "uk.transfer_to_fba": "Transfer to FBA Team",
    "uk.add_item_to_box": "Add Item to Box",
    "uk.boxed": "Boxed",
    "uk.planned": "Planned",
    "recv.warehouse": "Warehouse",
    "recv.no_assignment": "You are not assigned as receiver staff at any warehouse. Ask an administrator to assign you.",
    "recv.empty_active": "No pallets are on their way or waiting for boxing.",
    "recv.empty_history": "Fully boxed pallets will appear here.",
    "recv.loading_error": "Could not load pallets.",
    "recv.error": "Something went wrong. Please try again.",
    "recv.receive_pallet": "Receive pallet",
    "recv.receive_title": "Receive this pallet?",
    "recv.receive_body": "Confirm that the whole pallet has arrived at this warehouse. This applies to every tenant's work on it.",
    "recv.received": "Pallet received.",
    "recv.received_diff": "Pallet received. {{count}} differences were recorded for the tenants.",
    "recv.count_title": "Count and receive pallet",
    "recv.count_body": "Check the quantities below. They are filled with the declared amounts; change only what differs.",
    "recv.count_load_error": "Could not load the pallet items.",
    "recv.count_all_match": "Everything matches",
    "recv.count_add_unexpected": "Add unexpected product",
    "recv.count_unexpected": "Unexpected products",
    "recv.count_tenant": "Tenant",
    "recv.count_product": "Product (ASIN or name)",
    "recv.count_no_product": "No matching product in the catalog",
    "recv.count_remove": "Remove",
    "recv.count_short": "{{count}} missing",
    "recv.count_over": "{{count}} extra",
    "recv.discrepancies_count": "Receiving differences · {{count}} product(s)",
    "recv.discrepancy_waiting": "Waiting for the tenant to acknowledge.",
    "recv.damage_report": "Report damage",
    "recv.damage_title": "Report damaged items",
    "recv.damage_body": "Units found damaged while boxing. The tenant has to acknowledge and correct the plan.",
    "recv.damage_item": "Item",
    "recv.damage_good_left": "{{count}} good",
    "recv.damage_qty": "Damaged units",
    "recv.damage_reported": "Damage reported.",
    "recv.photo_add": "Add photo",
    "recv.photo_added": "Photo added.",
    "recv.photo_error": "The photo could not be added.",
    "disc.declared": "Declared",
    "disc.good": "Good",
    "disc.damaged": "Damaged",
    "disc.missing": "Missing",
    "disc.extra": "Extra",
    "disc.type.SHORT": "Short",
    "disc.type.DAMAGED": "Damaged",
    "disc.type.OVER": "Over",
    "disc.type.UNEXPECTED": "Unexpected",
    "disc.type.BOXING_DAMAGE": "Damaged while boxing",
    "disc.status.OPEN": "Open",
    "disc.status.ACKNOWLEDGED": "Acknowledged",
    "disc.accepted": "Accepted extra: {{count}}",
    "disc.photos": "Photos",
    "planning.discrepancy_open": "Differences to acknowledge",
    "planning.discrepancy_title": "The counted pallet differs from your declaration",
    "planning.discrepancy_body": "Planning uses the usable quantity. Acknowledge the differences, adjust your distribution, then submit again.",
    "planning.accept_extra": "Accept extra units (max {{max}})",
    "planning.acknowledge": "Acknowledge differences",
    "planning.acknowledged": "Differences acknowledged.",
    "planning.proportional": "Reduce proportionally",
    "planning.proportional_hint": "Suggested: lowers every store allocation in proportion to the usable quantity.",
    "planning.proportional_done": "Distribution reduced.",
    "planning.preliminary": "Preliminary plan: it may change once the pallet is counted at the destination.",
    "planning.counted": "Declared {{declared}} · good {{good}} · damaged {{damaged}}",
    "planning.correction_mode": "Boxing is in progress. You can only reduce allocations down to the usable quantity, and not below what is already boxed.",
    "recv.receive_first": "Receive the pallet before boxing can start.",
    "recv.planning_pending": "The tenant has not sent its plan yet. You can box the lines it already distributed, but boxing can only be finished after the plan is sent.",
    "recv.read_only": "Boxing is complete. This work is read-only.",
    "labels.files_title": "Label files",
    "labels.state.NONE": "No label yet",
    "labels.state.READY": "Label ready",
    "labels.state.APPLIED": "Done",
    "labels.mark_done": "Labels done",
    "labels.done": "Done",
    "labels.undo_applied": "Undo",
    "labels.complete_title": "Complete this work?",
    "labels.complete_body": "This is the last open label file. Confirming it completes the work, notifies the tenant and cannot be undone from this screen.",
    "labels.complete_confirm": "Yes, complete",
    "labels.waiting": "{{count}} box(es) with labels to print",
    "labels.popup_blocked": "The browser blocked the print tabs. Allow pop-ups for this site and try again.",
    "labels.applied_msg": "Box marked as labelled",
    "labels.unapplied_msg": "Box marked as not labelled",
    "labels.completed_msg": "All boxes are labelled. This work is complete.",
    "mkt.empty_title": "No boxes waiting for labels",
    "mkt.empty_hint": "Boxes appear here once the receiving warehouse marks them ready.",
    "mkt.card_ready": "{{ready}} of {{count}} boxes ready",
    "mkt.card_progress": "{{labelled}}/{{count}} boxes labelled",
    "mkt.waiting_banner": "Upload the FBA and shipment labels for every ready box. The receiving warehouse prints and applies them.",
    "mkt.completed_banner": "All boxes are labelled. This work is complete.",
    "mkt.no_boxes": "No ready boxes yet",
    "mkt.upload_for_store": "Upload label for {{store}}",
    "mkt.upload_hint": "PDF, PNG or JPG. One file can cover several boxes.",
    "mkt.drop_here": "Drop label here",
    "mkt.assign_title": "Assign label to boxes",
    "mkt.assign_body": "Which boxes are included in {{file}}?",
    "mkt.select_all": "Select all ({{count}})",
    "mkt.assign_save": "Assign to {{count}} box(es)",
    "mkt.already_labeled": "Already has a label",
    "mkt.assigned": "Label assigned to {{count}} box(es)",
    "mkt.label_removed": "Label removed",
    "mkt.contents": "Contents",
    "mkt.labels": "Labels",
    "mkt.applied_lock": "The warehouse applied these labels, so they can no longer be removed.",
    "status.COMPLETED": "Completed",
    "us.work.COMPLETED": "Completed",
    "notification.type.LABELS_READY": "{{tenant_name}} uploaded labels for {{count}} box(es). Ready to print.",
    "notification.type.WORK_COMPLETED": "All boxes are labelled. The work is complete.",
    "notification.type.DB_BACKUP_FAILED": "An automatic database backup failed: {{error}}",
    "notification.type.FILE_BACKUP_FAILED": "An automatic file backup failed: {{error}}",
    "maintenance.toast": "The system is in maintenance mode. Changes cannot be saved right now; try again later.",
    "maintenance.banner": "The system is in maintenance mode. Changes cannot be saved. Please wait before you do any work; this message goes away when maintenance is over.",
    "maintenance.banner_platform": "MAINTENANCE MODE IS ON. Everyone else is locked out of saving; only you, the platform administrator, can change data. Turn it off in the DB Backup tab when you are done.",
    "adm.db.maint_title": "Maintenance mode",
    "adm.settings.saved": "Setting saved",
    "adm.settings.over_stock": "Allow pallet items over the shelf stock",
    "adm.settings.over_stock_on": "On: the sender can put more on a pallet than the stock shows on the shelf, with a warning.",
    "adm.settings.over_stock_off": "Off: the sender cannot put more on a pallet than the stock shows on the shelf.",
    "adm.db.maint_on": "ON: only the platform administrator can change data. Everyone else can only view. It stays on until you turn it off.",
    "adm.db.maint_off": "Off. Turn it on before a restore, so nobody writes into the database meanwhile.",
    "adm.db.maint_turn_on": "Turn on",
    "adm.db.maint_turn_off": "Turn off",
    "adm.db.maint_turned_on": "Maintenance mode is on",
    "adm.db.maint_turned_off": "Maintenance mode is off",
    "adm.db.export_title": "Download a backup",
    "adm.db.export_intro": "Downloads the whole database as a zip, encrypted (AES-256) with your password. Open it with 7-Zip. Uploaded files (labels, photos) are not in it.",
    "adm.db.your_password": "Your password",
    "adm.db.export": "Download backup",
    "adm.db.exported": "Backup downloaded",
    "adm.db.restore_title": "Restore from a zip",
    "adm.db.restore_intro": "Replaces the WHOLE database with the zip: our own backup or a Mongo Viewer dump. Steps: turn maintenance mode on, preview, check the numbers, replace. A safety copy of the current database is saved to the backup bucket first.",
    "adm.db.zip_file": "Zip file",
    "adm.db.zip_password": "Zip password",
    "adm.db.zip_password_hint": "only for an encrypted zip",
    "adm.db.preview": "Preview",
    "adm.db.collection": "Collection",
    "adm.db.now": "Now",
    "adm.db.after": "After restore",
    "adm.db.emptied_note": "Red rows will be emptied: the zip has no data for them.",
    "adm.db.no_tools_user": "The zip has no platform administrator account. Restoring it would lock you out, so it is refused.",
    "adm.db.needs_maintenance": "Turn maintenance mode on first.",
    "adm.db.needs_bucket": "The backup bucket is not set up (R2_BACKUP_* and BACKUP_ZIP_PASSWORD). Automatic backups and restores need it.",
    "adm.db.replace": "Replace database",
    "adm.db.confirm_title": "Replace the whole database?",
    "adm.db.confirm_body": "All current data is replaced by the zip. A safety copy is saved first. Maintenance mode stays on afterwards: check the data, then turn it off. You may have to sign in again.",
    "adm.db.restored": "{{n}} records restored. Safety copy: {{key}}. Maintenance mode is still on.",
    "adm.db.auto_title": "Automatic backups",
    "adm.db.auto_intro": "Each rule saves an encrypted backup to the R2 backup bucket (password: BACKUP_ZIP_PASSWORD) and keeps only its newest N files. A backup missed while the server was down is taken once when it is back. Nothing runs in maintenance mode.",
    "adm.db.backup_now": "Back up now",
    "adm.db.saved": "Backup saved to the bucket",
    "adm.db.add_rule": "Add rule",
    "adm.db.edit_rule": "Edit rule",
    "adm.db.no_rules": "No automatic backups yet.",
    "adm.db.rule_daily": "Every day at {{time}}",
    "adm.db.rule_days": "Every {{n}} days at {{time}}",
    "adm.db.rule_weeks": "Every {{n}} week(s) on {{day}} at {{time}}",
    "adm.db.rule_months": "Every {{n}} month(s) on day {{day}} at {{time}}",
    "adm.db.rule_invalid": "Check the values: every 1–31 days / 1–54 weeks / 1–12 months, day 1–28, keep 1–365.",
    "adm.db.keep_n": "keeps the last {{n}}",
    "adm.db.last_run": "Last run",
    "adm.db.next_run": "Next",
    "adm.db.timezone": "Times are UK time (Europe/London).",
    "adm.fb.title": "File backups",
    "adm.fb.intro": "Copies of the uploaded files (labels and photos) in the backup bucket. Each run copies only the files that are not there yet, and copies are kept for good. A file deleted in the app is hidden at once; the next run copies it, removes it from the main bucket, and keeps its copy for the number of days set in the rule. There is no restore here: copy the files back by hand.",
    "adm.fb.add_rule": "Add file backup rule",
    "adm.fb.edit_rule": "Edit file backup rule",
    "adm.fb.run_now": "Run now",
    "adm.fb.ran": "File backup finished",
    "adm.fb.keep_deleted": "Keep copies of deleted files (days)",
    "adm.fb.keep_deleted_n": "deleted files kept {{n}} days",
    "adm.fb.result": "{{copied}} copied, {{pruned}} removed from backup",
    "adm.db.unit": "Repeat",
    "adm.db.unit_day": "Daily",
    "adm.db.unit_week": "Weekly",
    "adm.db.unit_month": "Monthly",
    "adm.db.every_day": "Every how many days (1–31)",
    "adm.db.every_week": "Every how many weeks (1–54)",
    "adm.db.every_month": "Every how many months (1–12)",
    "adm.db.weekday": "Day",
    "adm.db.month_day": "Day of month (1–28)",
    "adm.db.time": "Time",
    "adm.db.keep": "Keep last (files)",
    "adm.db.wd.0": "Monday",
    "adm.db.wd.1": "Tuesday",
    "adm.db.wd.2": "Wednesday",
    "adm.db.wd.3": "Thursday",
    "adm.db.wd.4": "Friday",
    "adm.db.wd.5": "Saturday",
    "adm.db.wd.6": "Sunday",
    "adm.db.files_title": "Latest 20 backups in the bucket",
    "adm.db.no_files": "No backups in the bucket yet.",
    "adm.db.download": "Download",
    "adm.db.kind_auto": "Automatic (deleted rule)",
    "adm.db.kind_now": "Backup now",
    "adm.db.kind_pre": "Safety copy before a restore",
    "adm.db.files_note": "Files here are encrypted with BACKUP_ZIP_PASSWORD. Restore one by downloading it and using \"Restore from a zip\" with that password.",
    "recv.revision_open": "Correction request open",
    "recv.items_units": "{{count}} item types · {{units}} units",
    "recv.boxes_ready": "{{ready}}/{{count}} boxes ready",
    "recv.box_count": "{{count}} box(es)",
    "recv.item_types": "{{count}} item type(s)",
    "recv.add_box": "Add box",
    "recv.boxes_title": "Boxes",
    "recv.store_no_boxes": "No boxes for this store yet",
    "recv.store_no_boxes_hint": "Open the first box to start packing its products.",
    "recv.store_all_boxed": "All boxed",
    "recv.store_summary": "{{boxes}} box(es) · {{ready}} ready · {{boxed}}/{{planned}} units boxed",
    "recv.store_summary_labels": "{{boxes}} box(es) · {{labelled}} with label · {{applied}} done",
    "mkt.pages_mismatch": "This file has {{pages}} page(s) but {{count}} box(es) are selected. Expected {{count}} or {{double}} pages (label only, or label + shipping label). Check the file and the boxes.",
    "recv.store_plan": "Store plan",
    "recv.plan_summary": "{{types}} item type(s) · {{boxed}}/{{planned}} units",
    "recv.dims_set": "Dimensions set",
    "recv.sum_units": "{{boxed}} / {{planned}} products boxed",
    "recv.sum_boxes_opened": "boxes opened",
    "recv.sum_boxes_ready": "boxes ready",
    "recv.sum_labelled": "{{applied}} / {{count}} boxes labelled",
    "recv.band_show": "Show details",
    "recv.band_hide": "Hide details",
    "product.show_image": "Show product image",
    "product.image_missing": "No image found for this product.",
    "recv.left": "{{count}} left",
    "recv.box_ready": "Ready",
    "recv.box_locked": "This box is marked ready and locked. Reopen it to make changes.",
    "recv.mark_ready": "Mark box ready",
    "recv.reopen_box": "Reopen box",
    "recv.box_marked_ready": "Box marked ready.",
    "recv.box_reopened": "Box reopened.",
    "recv.set_dims": "Set dimensions",
    "recv.dims_needed": "Dimensions needed",
    "recv.dims_required": "Weight and dimensions are required before the box can be marked ready.",
    "recv.dims_title": "Box weight and dimensions",
    "recv.dims_saved": "Box dimensions saved.",
    "recv.box_size": "Box size",
    "recv.custom_size": "Custom size",
    "recv.dims_range": "Weight and sizes must be more than 0 and at most 100.",
    "recv.select_store": "Select store...",
    "recv.no_store_left": "All products of every store are already boxed.",
    "recv.box_name_placeholder": "Generated automatically if empty",
    "recv.box_created": "Box created.",
    "recv.box_deleted": "Box deleted.",
    "recv.delete_box": "Delete box",
    "recv.delete_box_body": "All items in this box return to the store plan. This cannot be undone.",
    "recv.box_items": "Box items ({{count}})",
    "recv.box_empty": "No items in this box yet.",
    "recv.add_item": "Add item",
    "recv.item_added": "Item added to box.",
    "recv.item_removed": "Item removed.",
    "recv.search_placeholder": "Search by ASIN, FNSKU or product name...",
    "recv.max": "max {{count}}",
    "recv.over_title": "More than planned",
    "recv.over_body": "{{name}}: the plan is {{planned}}, this makes {{boxed}} (+{{count}} over the plan). The tenant will be told. Give a reason.",
    "recv.over_reason": "Reason",
    "recv.over_r.EXTRA_ON_PALLET": "More units on the pallet",
    "recv.over_r.COUNT_DIFF": "Counting difference",
    "recv.over_r.OTHER": "Other (note required)",
    "recv.over_note": "Note",
    "recv.over_confirm": "Box the extra units",
    "recv.over_badge": "+{{count}} over plan",
    "planning.over_note": "The warehouse boxed {{count}} more than you planned.",
    "recv.set_max": "Use maximum remaining ({{count}})",
    "recv.complete_boxing": "Complete boxing",
    "recv.complete_title": "Complete boxing for {{tenant}}?",
    "recv.complete_body": "Every box is ready and matches the plan. The tenant's marketplace stage can start.",
    "recv.boxing_completed": "Boxing completed.",
    "recv.request_correction": "Request correction",
    "recv.correction_open": "Correction requested",
    "recv.correction_title": "Request a correction",
    "recv.correction_body": "The tenant is told what to fix. Boxing cannot be completed until the request is resolved.",
    "recv.correction_sent": "Correction request sent.",
    "recv.return_planning": "Return to planning",
    "recv.return_title": "Return this work to planning?",
    "recv.return_body": "The tenant has to change its plan. Existing boxes stay. Describe what needs to change.",
    "recv.returned": "Work returned to planning.",
    "recv.note_placeholder": "Describe the issue...",
    "recv.send": "Send",
    "recv.print_all_fnsku": "Print all FNSKU",
    "recv.print_fnsku": "Print FNSKU",
    "recv.print_fnsku_for": "Print FNSKU for {{name}}",
    "recv.print_quantity": "Print quantity for {{name}}",
    "recv.print_decrease": "Decrease print quantity for {{name}}",
    "recv.print_increase": "Increase print quantity for {{name}}",
    "recv.fnsku_missing": "FNSKU missing",
    "recv.no_fnsku": "No FNSKU available",
    "recv.no_printable": "No printable FNSKU labels found for this store.",
    "recv.nothing_to_print": "No remaining quantities to print.",
    "recv.printing": "Printing {{count}} FNSKU label(s)",
    "recv.printed_skipped": "Printed {{count}} labels. Skipped {{skipped}} item(s) without FNSKU.",
    "recv.print_failed": "Could not print FNSKU labels. Check your browser's print dialog settings and try again.",
    "fba.upload_label": "Upload Label",
    "fba.fba_label": "FBA Label",
    "fba.shipping_label": "Shipping Label",
    "fba.complete": "Mark Complete",
    "fba.labels_required": "Min. 2 labels required per box",
    "admin.users": "Users",
    "admin.products": "Products",
    "admin.stores": "Stores",
    "admin.store_fnsku": "Store FNSKU",
    "admin.create_user": "Create User",
    "adm.us.create_staff": "Add Warehouse Staff",
    "admin.import_products": "Import Products",
    "admin.import_fnsku": "Import FNSKU",
    "admin.role": "Role",
    "admin.email": "Email",
    "admin.password": "Password",
    "admin.category": "Category",
    "admin.ean": "EAN",
  },
  tr: {
    "app.name": "BoxPrep",
    "nav.dashboard": "Genel Bakış",
    "nav.sender_warehouse": "Gönderici Depo",
    "nav.planning": "Planlama",
    "nav.receiver_warehouse": "Alıcı Depo",
    "nav.marketplace_amazon_fba": "Amazon FBA",
    "nav.admin": "Yönetim",
    "nav.logout": "Çıkış",
    "whatsnew.button": "Yenilikler",
    "whatsnew.title": "Yenilikler",
    "whatsnew.empty": "Henüz sürüm notu yok.",
    "whatsnew.new": "Yeni",
    "login.subtitle": "Depo Yönetim Sistemi",
    "login.sign_in": "Giriş Yap",
    "login.signing_in": "Giriş yapılıyor...",
    "login.email": "E-posta",
    "login.password": "Şifre",
    "login.invalid": "E-posta veya şifre hatalı",
    "nav.management": "Yönetim",
    "role.platform_admin": "Platform Yöneticisi",
    "role.tenant_admin": "Tenant Yöneticisi",
    "role.tenant_member": "Tenant Üyesi",
    "role.warehouse_staff": "Depo Personeli",
    "adm.error": "Bir hata oluştu",
    "adm.optional": "isteğe bağlı",
    "adm.deleted": "Silindi",
    "adm.delete_title": "\"{{name}}\" silinsin mi?",
    "adm.delete_warning": "Bu işlem geri alınamaz.",
    "adm.pr.new": "Yeni Ürün",
    "adm.pr.name": "Ürün Adı",
    "adm.pr.search": "Genel arama (ASIN / ad / EAN)...",
    "adm.pr.empty": "Ürün bulunamadı.",
    "adm.pr.created": "Ürün oluşturuldu",
    "adm.pr.deleted": "Ürün silindi",
    "adm.pr.duplicate": "Bu ASIN katalogda zaten var. Mevcut ürün değiştirilmedi.",
    "adm.pr.csv_hint": "Dosya sütunları: ASIN, PRODUCT_NAME, EAN (isteğe bağlı), CATEGORY (isteğe bağlı). Mevcut ASIN'lerin üzerine yazılmaz.",
    "adm.st.new": "Yeni Mağaza",
    "adm.st.name": "Mağaza Adı",
    "adm.st.empty": "Henüz mağaza yok.",
    "adm.st.created": "Mağaza oluşturuldu",
    "adm.st.deleted": "Mağaza silindi",
    "adm.fn.add": "FNSKU Ekle",
    "adm.fn.code": "FNSKU Kodu",
    "adm.fn.select_store": "Mağaza seçin...",
    "adm.fn.saved": "FNSKU kaydedildi",
    "adm.fn.empty": "Henüz FNSKU yok. ASIN, STORE_NAME, FNSKU sütunlu bir dosya içe aktarın.",
    "adm.fn.csv_hint": "Dosya sütunları: ASIN, STORE_NAME, FNSKU. Olmayan mağazalar tenant'ınız için oluşturulur.",
    "adm.capped_search": "Yalnızca ilk {{count}} kayıt gösteriliyor. Diğerlerini bulmak için arama kutusunu kullanın.",
    "adm.capped": "Yalnızca ilk {{count}} kayıt gösteriliyor; diğerleri listelenmiyor.",
    "adm.us.deleted": "Kullanıcı silindi",
    "adm.import.button": "Dosya İçe Aktar",
    "adm.import.title": "İçe aktarma sonucu",
    "adm.import.failed": "İçe aktarma başarısız",
    "adm.import.imported": "{{count}} satır içe aktarıldı",
    "adm.import.duplicates": "{{count}} satır atlandı: ASIN zaten var",
    "adm.import.duplicates_hint": "Katalogdaki mevcut ürünlerin üzerine yazılmaz.",
    "adm.import.errors": "{{count}} satır reddedildi",
    "adm.import.more": "ve {{count}} satır daha",
    "adm.import.row": "Satır {{row}}",
    "adm.import.reason.missing_asin": "ASIN eksik",
    "adm.import.reason.missing_product_name": "Ürün adı eksik",
    "adm.import.reason.missing_value": "ASIN, mağaza adı veya FNSKU eksik",
    "adm.import.reason.unknown_asin": "ASIN ürün listenizde yok",
    "adm.import.reason.invalid_asin": "ASIN eksik veya çok uzun",
    "adm.import.reason.invalid_quantity": "QTY 1 veya daha büyük bir tam sayı olmalı",
    "adm.import.reason.invalid_order_id": "ORDER_ID eksik veya çok uzun",
    "adm.code": "Kod",
    "adm.tn.id": "ID",
    "adm.tn.copy_id": "Tenant ID'sini kopyala",
    "adm.tn.id_copied": "Tenant ID kopyalandı",
    "adm.country": "Ülke",
    "adm.active": "Aktif",
    "adm.inactive": "Pasif",
    "adm.suspended": "Askıda",
    "adm.suspend": "Askıya Al",
    "adm.activate": "Etkinleştir",
    "adm.deactivate": "Pasifleştir",
    "adm.tab.tenants": "Tenant'lar",
    "adm.tab.warehouses": "Depolar",
    "adm.tab.users": "Kullanıcılar",
    "adm.tab.route": "Rota",
    "adm.tab.products": "Ürün Kataloğu",
    "adm.tab.stores": "Mağazalar",
    "adm.tab.fnsku": "Mağaza FNSKU",
    "adm.tab.testdata": "Test Verisi",
    "adm.tab.dbbackup": "DB Yedek",
    "adm.tab.settings": "Ayarlar",
    "adm.tab.inbound": "Gelen ürün",
    "adm.tr.title": "Backend testlerini çalıştır",
    "adm.tr.intro": "Tüm backend test paketini bu sunucuda çalıştırır. Veritabanında test verisi oluşturur ve siler, birkaç dakika sürer. Yalnız geliştirme/test ortamında açıktır.",
    "adm.tr.start": "Testleri çalıştır",
    "adm.tr.clear": "Sonucu temizle",
    "adm.tr.running": "Çalışıyor...",
    "adm.tr.passed": "Geçti",
    "adm.tr.failed": "Başarısız",
    "adm.tr.already": "Bir test çalıştırması zaten sürüyor",
    "adm.td.title": "Test verisini sil",
    "adm.td.intro": "Aşağıdaki test adlandırmasını taşıyan verileri ve ona bağlı her şeyi (palet, koli, etiket, bildirim) bulur ve siler. Gerçek veriler eşleşmez.",
    "adm.td.rule_tenant": "Tenant kodu şununla başlar",
    "adm.td.rule_warehouse": "Depo kodu şununla başlar",
    "adm.td.rule_email": "Kullanıcı e-postası",
    "adm.td.rule_asin": "Ürün ASIN'i şununla başlar",
    "adm.td.scan": "Yeniden tara",
    "adm.td.delete": "Test verisini sil",
    "adm.td.empty": "Test verisi bulunamadı.",
    "adm.td.total": "Toplam kayıt",
    "adm.td.files_note": "{{n}} yüklenen dosya: R2 depolamadaki dosyalar gerçekten silinir. Eski Emergent depolamadaki dosyalar silinemez, orada kalır; yalnız kayıtları silinir.",
    "adm.td.confirm_title": "{{n}} test kaydı silinsin mi?",
    "adm.td.confirm_body": "Bu işlem geri alınamaz. Yalnız test adlandırmasına uyan kayıtlar silinir.",
    "adm.td.done": "{{n}} test kaydı silindi",
    "adm.td.changed": "Tarama sonrası veri değişti. Yeniden tarayıp tekrar deneyin.",
    "adm.td.seed": "Test verisi yükle",
    "adm.td.seeded": "Test verisi yüklendi ({{n}} kullanıcı)",
    "adm.td.seed_result": "Tüm hesapların şifresi: {{password}}",
    "adm.td.seed_counts": "{{tenants}} tenant, {{warehouses}} depo, {{users}} kullanıcı, {{products}} ürün, {{stores}} mağaza, {{fnsku}} FNSKU eşlemesi",
    "adm.cap.SENDER": "Gönderici",
    "adm.cap.RECEIVER": "Alıcı",
    "adm.marketplace.AMAZON_FBA": "Amazon FBA",
    "adm.wh.new": "Yeni Depo",
    "adm.wh.edit": "Depoyu Düzenle",
    "adm.wh.empty": "Henüz depo yok.",
    "adm.wh.capabilities": "Kabiliyetler",
    "adm.wh.address": "Adres",
    "adm.wh.contact_person": "Sorumlu kişi",
    "adm.wh.phone": "İletişim telefonu",
    "adm.wh.email": "İletişim e-postası",
    "adm.wh.created": "Depo oluşturuldu",
    "adm.wh.updated": "Depo güncellendi",
    "adm.wh.activated": "Depo etkinleştirildi",
    "adm.wh.deactivated": "Depo pasifleştirildi",
    "adm.tn.new": "Yeni Tenant",
    "adm.tn.edit": "Tenant'ı Düzenle",
    "adm.tn.empty": "Henüz tenant yok.",
    "adm.tn.open": "Rotaları ve yöneticileri aç",
    "adm.tn.multi_profile": "Birden fazla aktif rota profiline izin ver",
    "adm.tn.inbound": "Inbound ve Stok",
    "adm.tn.inbound_hint": "Kapalıysa Tenant ve gönderici depo personeli bu Tenant'ın Inbound ve Stok ekranlarını görmez, paletler stoğa karşı kontrol edilmez. Kayıtlı veri silinmez.",
    "adm.tn.marketplaces": "Satın alınan marketplace'ler",
    "adm.tn.marketplaces_hint": "Tenant yöneticileri bu marketplace'leri kullanabilir ve üyelerine verebilir. Hiçbiri otomatik etkinleşmez.",
    "adm.cap.title": "Yetkiler",
    "adm.cap.PLANNING": "Planlama",
    "adm.cap.marketplace": "Marketplace",
    "adm.cap.locked": "Yöneticiler tenant'ın sahip olduğu tüm yetkilere sahiptir. Bunu yalnızca platform yöneticisi değiştirebilir.",
    "adm.tn.add_admin": "Tenant yöneticisi ekle",
    "adm.tn.admin_created": "Tenant yöneticisi oluşturuldu",
    "adm.tn.admins": "Tenant yöneticileri",
    "adm.tn.no_admins": "Henüz yönetici yok.",
    "adm.tn.last_admin_warning": "Bu, tenant'ın son yöneticisi. Yeni bir yönetici ekleyene kadar tenant'ta kimse kullanıcı, mağaza veya ürün yönetemez.",
    "adm.us.tenant": "Tenant",
    "adm.us.reset_password": "Şifre sıfırla",
    "adm.us.new_password": "Yeni şifre",
    "adm.us.password_reset": "Şifre sıfırlandı",
    "adm.us.password_min": "En az 12 karakter.",
    "adm.us.reset_hint": "Yöneticinin açık oturumları kapanır ve yeni şifreyle yeniden giriş yapması gerekir.",
    "adm.tn.created": "Tenant oluşturuldu",
    "adm.tn.updated": "Tenant güncellendi",
    "adm.tn.status_changed": "Tenant durumu değişti",
    "adm.rp.title": "Rota profilleri",
    "adm.rp.new": "Yeni Rota Profili",
    "adm.rp.edit": "Rota Profilini Düzenle",
    "adm.rp.empty": "Henüz rota profili yok.",
    "adm.rp.source": "Kaynak depo",
    "adm.rp.destination": "Varış deposu",
    "adm.rp.marketplace": "Marketplace",
    "adm.rp.versions": "Sürümler",
    "adm.rp.select_warehouse": "Depo seçin...",
    "adm.rp.created": "Rota profili oluşturuldu",
    "adm.rp.updated": "Rota profili güncellendi",
    "adm.rp.status_changed": "Rota profili durumu değişti",
    "adm.us.edit": "Kullanıcıyı Düzenle",
    "adm.us.created": "Kullanıcı oluşturuldu",
    "adm.us.updated": "Kullanıcı güncellendi",
    "adm.us.keep_password": "korumak için boş bırakın",
    "adm.us.warehouses_title": "Depo atamaları",
    "adm.us.warehouses_saved": "Depo atamaları kaydedildi",
    "adm.nt.title": "Bildirimler",
    "adm.nt.empty": "Bildirim yok.",
    "adm.nt.mark_read": "Okundu işaretle",
    "adm.nt.ROUTE_PROFILE_CREATED": "{{code}} rota profili oluşturuldu.",
    "adm.nt.ROUTE_PROFILE_UPDATED": "{{code}} rota profili güncellendi (sürüm {{version}}).",
    "adm.nt.ROUTE_PROFILE_ACTIVATED": "{{code}} rota profili etkinleştirildi.",
    "adm.nt.ROUTE_PROFILE_DEACTIVATED": "{{code}} rota profili pasifleştirildi.",
    "common.cancel": "İptal",
    "common.refresh": "Yenile",
    "common.save": "Kaydet",
    "common.delete": "Sil",
    "common.edit": "Düzenle",
    "common.create": "Oluştur",
    "common.transfer": "Transfer Et",
    "common.search": "Ara...",
    "common.loading": "Yükleniyor...",
    "common.confirm": "Onayla",
    "common.back": "Geri",
    "common.add": "Ekle",
    "common.close": "Kapat",
    "common.upload": "Yükle",
    "common.import": "İçe Aktar",
    "common.name": "İsim",
    "common.quantity": "Miktar",
    "common.status": "Durum",
    "common.actions": "İşlemler",
    "common.notes": "Notlar",
    "common.date": "Tarih",
    "common.all": "Tümü",
    "common.filter": "Filtrele",
    "common.yes": "Evet",
    "common.no": "Hayır",
    "common.submit": "Gönder",
    "common.scan": "Tara",
    "common.filterPlaceholder": "Filtrele…",
    "scanner.cameraStalled": "Kamera önizlemesi takıldı. Lütfen kamera iznini verin veya cihazınızı kontrol edin.",
    "scanner.cameraUnavailable": "Kamera kullanılamıyor. Lütfen kamera iznini verin veya cihazınızı kontrol edin.",
    "scanner.starting": "Kamera başlatılıyor...",
    "scanner.scanning": "Taranıyor... barkod / QR'a doğrultun",
    "scanner.title": "Barkod / ASIN Tara",
    "scanner.hideManual": "Elle girişi gizle",
    "scanner.enterManually": "Elle gir",
    "scanner.manualPlaceholder": "ASIN / FNSKU / EAN...",
    "scanner.ok": "Tamam",
    "common.asin": "ASIN",
    "common.product": "Ürün",
    "common.store": "Mağaza",
    "common.box": "Koli",
    "common.pallet": "Palet",
    "common.items": "Ürünler",
    "common.boxes": "Koliler",
    "us.create_pallet": "Palet Oluştur",
    "us.pallet_name": "Palet Adı",
    "us.add_item": "Ürün Ekle",
    "us.show_transferred": "Transfer Edilmişleri Göster",
    "us.show_active": "Aktif Paletleri Göster",
    "us.scan_or_search": "Ürün Tara veya Ara",
    "us.route": "Rota",
    "us.select_route": "Rota seçin...",
    "us.tenant": "Tenant",
    "us.select_tenant": "Tenant seçin...",
    "us.no_routes": "Deponuz için tanımlı bir rota yok.",
    "us.mark_ready": "Hazır",
    "us.start_shipment": "Sevkiyatı Başlat",
    "us.ready_title": "Palet hazır işaretlensin mi?",
    "us.ready_body": "Ürünler artık değiştirilemez. Tenant'lar hemen planlamaya başlayabilir.",
    "us.ship_title": "Sevkiyat başlatılsın mı?",
    "us.ship_body": "Paletin depodan çıktığını onaylayın. Rota ve içerik artık değiştirilemez.",
    "us.final_notice": "İçerik kesinleşti. Tenant'lar ürünlerini planlayabilir. Palet çıkınca sevkiyatı başlatın.",
    "us.shipped_notice": "Palet yolda. İçerik artık değiştirilemez.",
    "us.received_notice": "Palet varış deposunda kabul edildi.",
    "us.work.PLANNING": "Planlamada",
    "us.work.SUBMITTED": "Depoya gönderildi",
    "us.work.BOXING": "Kolileniyor",
    "us.work.BOXED": "Kolilendi",
    "us.tenant_summary": "{{count}} çeşit · {{units}} adet",
    "us.msg.added": "{{name}} eklendi ({{qty}} adet)",
    "us.msg.over_stock": "Eklendi, ama rafta bu üründen yeterli yok (Rafta: {{n}}). Gelen ürün kayıtlarında bir teslimat eksik olabilir.",
    "us.msg.removed": "Ürün kaldırıldı",
    "us.msg.created": "Palet oluşturuldu",
    "us.msg.deleted": "Palet silindi",
    "us.msg.ready": "Palet hazır işaretlendi",
    "us.msg.shipped": "Sevkiyat başlatıldı",
    "us.search_placeholder": "ASIN, EAN veya ürün adı ile ara...",
    "us.no_approved_match": "Bu tenant'ın onaylı listesinde ürün bulunamadı. Tenant ürünü önce kendi ürün listesine eklemelidir.",
    "us.no_items": "Henüz ürün yok. Palete ürün ekleyin.",
    "us.no_pallets": "Palet bulunamadı",
    "us.no_pallets_hint": "Başlamak için ilk paletinizi oluşturun",
    "us.pallet_name_placeholder": "Palet adı...",
    "us.notes_placeholder": "İsteğe bağlı notlar...",
    "us.types": "{{count}} çeşit",
    "us.units": "{{count}} adet",
    "us.filter_active": "Aktif",
    "us.filter_history": "Geçmiş",
    "us.creating": "Oluşturuluyor...",
    "us.remove_item": "Ürün kaldırılsın mı?",
    "us.remove": "Kaldır",
    "us.delete_pallet": "Palet silinsin mi?",
    "status.DRAFT": "Hazırlanıyor",
    "status.READY": "Hazır",
    "status.IN_TRANSIT": "Yolda",
    "status.RECEIVED": "Kabul Edildi",
    "status.PLANNING": "Planlamada",
    "status.SUBMITTED": "Alıcı depoya gönderildi",
    "status.BOXING": "Kolileniyor",
    "status.BOXED": "Kolilendi",
    "dash.subtitle": "Operasyon merkezi",
    "dash.load_error": "Genel bakış yüklenemedi.",
    "dash.work_title": "İş durumu",
    "dash.physical_title": "Fiziksel paletler",
    "dash.physical_hint": "Depolarınızdaki palet hareketi; tenant işlerinden ayrıdır.",
    "dash.attention_title": "Dikkat gerektirenler",
    "dash.attention_hint": "Hızlı takip gerektiren açık kalemler",
    "dash.attention.open_discrepancies": "Açık kabul farkları",
    "dash.attention.open_revisions": "Açık düzeltme istekleri",
    "dash.attention.unlabeled_ready_boxes": "Etiketsiz hazır koliler",
    "dash.attention.stalled_work": "7+ gündür değişmeyen",
    "dash.cycle_title": "Döngü süreleri",
    "dash.cycle.ship_to_receive_hours": "Sevkten kabule",
    "dash.cycle.queue_to_boxing_hours": "Kuyruktan kolilemeye",
    "dash.cycle.boxing_hours": "Kolileme",
    "dash.cycle.labelling_hours": "Kolilemeden etikete",
    "dash.avg_hours": "ortalama saat",
    "dash.activity_title": "Son hareketler",
    "dash.activity_empty": "Henüz aktivite yok",
    "dash.system": "Sistem",
    "dash.event.PALLET_CREATED": "Palet oluşturuldu",
    "dash.event.PALLET_MARKED_READY": "Palet hazır yapıldı",
    "dash.event.PALLET_SHIPPED": "Palet sevk edildi",
    "dash.event.PALLET_RECEIVED": "Palet kabul edildi",
    "dash.event.PLANNING_SUBMITTED": "Planlama alıcıya gönderildi",
    "dash.event.PLANNING_REOPENED": "Planlama yeniden açıldı",
    "dash.event.DISTRIBUTION_CREATED": "Dağıtım oluşturuldu",
    "dash.event.DISTRIBUTION_UPDATED": "Dağıtım güncellendi",
    "dash.event.BOX_CREATED": "Koli oluşturuldu",
    "dash.event.BOX_UPDATED": "Koli güncellendi",
    "dash.event.BOX_DELETED": "Koli silindi",
    "dash.event.BOX_READY": "Koli hazır yapıldı",
    "dash.event.BOX_REOPENED": "Koli yeniden açıldı",
    "dash.event.BOXING_COMPLETED": "Kolileme tamamlandı",
    "dash.event.WORK_RETURNED_TO_PLANNING": "Planlamaya geri gönderildi",
    "dash.event.DISCREPANCY_RECORDED": "Kabul farkı kaydedildi",
    "dash.event.DISCREPANCY_ACKNOWLEDGED": "Kabul farkı onaylandı",
    "dash.event.DAMAGE_REPORTED": "Hasar bildirildi",
    "dash.event.BOX_ITEM_OVER_PLAN": "Plandan fazla koliledi",
    "dash.event.INBOUND_ITEM_CREATED": "Gelen ürün satırı eklendi",
    "dash.event.INBOUND_ITEM_UPDATED": "Gelen ürün sipariş adedi değişti",
    "dash.event.INBOUND_ITEM_DELETED": "Gelen ürün satırı silindi",
    "dash.event.INBOUND_ITEM_CLOSED": "Gelen ürün satırı eksik kapatıldı",
    "dash.event.INBOUND_RECEIVED": "Gönderici depoda ürün teslim alındı",
    "dash.event.INBOUND_UNANNOUNCED": "Habersiz gelen ürün kaydedildi",
    "dash.event.INBOUND_OWNER_ASSIGNED": "Ürüne sahip atandı",
    "dash.event.INBOUND_DAMAGE_ACKNOWLEDGED": "Gelen ürün hasarı görüldü",
    "dash.event.INBOUND_PHOTO_ADDED": "Gelen ürün fotoğrafı eklendi",
    "dash.event.WORK_REVISION_REQUESTED": "Düzeltme istendi",
    "dash.event.WORK_REVISION_RESOLVED": "Düzeltme çözüldü",
    "dash.event.WORK_ITEM_ADDED": "Tenant palete ürün ekledi",
    "dash.event.WORK_ITEM_UPDATED": "Tenant palet kalemi adedini değiştirdi",
    "dash.event.WORK_ITEM_REMOVED": "Tenant palet kalemini sildi",
    "dash.event.LABEL_UPLOADED": "Etiket yüklendi",
    "dash.event.LABEL_DELETED": "Etiket silindi",
    "dash.event.LABELS_PRINTED": "Etiketler yazdırıldı",
    "dash.event.BOX_LABELS_APPLIED": "Etiketler yapıştırıldı",
    "dash.event.BOX_LABELS_UNAPPLIED": "Etiket işareti kaldırıldı",
    "dash.event.MARKETPLACE_COMPLETED": "Marketplace adımı tamamlandı",
    "planning.back": "Planlama listesine dön",
    "planning.active": "Aktif",
    "planning.history": "Geçmiş",
    "planning.empty_title": "Planlama işi bulunmuyor",
    "planning.empty_active": "Rotalı palete ürün eklendiğinde işler burada görünür.",
    "planning.empty_history": "Gönderilen ve tamamlanan işler burada görünür.",
    "planning.loading_error": "Planlama işleri yüklenemedi.",
    "planning.detail_error": "Planlama işi yüklenemedi.",
    "planning.read_only": "Bu iş gönderildi. Dağıtımlar artık değiştirilemez.",
    "planning.platform_read_only": "Platform görünümü salt okunurdur.",
    "planning.arrival": "Fiziksel palet",
    "planning.items": "{{count}} ürün çeşidi",
    "planning.units": "{{count}} adet",
    "planning.tenant": "Tenant",
    "planning.all_tenants": "Tüm tenant'lar",
    "planning.distributed": "Dağıtım tamamlandı",
    "planning.remaining": "{{count}} adet kaldı",
    "planning.add_store": "Mağaza ekle",
    "planning.revise_tip": "Adedi revize et",
    "planning.revise_note": "Kısa not (isteğe bağlı)",
    "planning.revise_save": "Kaydet",
    "planning.revise_done": "Adet revize edildi",
    "planning.revised": "Revize",
    "planning.revised_was": "Revize (önceki {{count}})",
    "planning.boxed_note": "Depo şimdiden {{count}} adedi koliledi. Bunun altına inemezsiniz.",
    "planning.add_store_more": "Başka mağaza ekle",
    "planning.progress": "Mağaza dağılımı",
    "planning.modal_title": "Dağıt: {{name}}",
    "planning.no_fnsku": "Bu ürün için FNSKU eşlemesi yok.",
    "planning.add_fnsku_hint": "Ürünü dağıtmadan önce Yönetim bölümünden FNSKU eşlemesi ekleyin.",
    "planning.all_stores_used": "Bu ürünün FNSKU'su olan her mağazaya bu palette zaten dağıtım yapılmış.",
    "planning.select_store": "Mağaza seçin",
    "planning.loading_stores": "Mağazalar yükleniyor...",
    "planning.quantity": "Adet",
    "planning.set_max": "Kalan miktarı kullan",
    "planning.add": "Dağıtımı ekle",
    "planning.save": "Kaydet",
    "planning.cancel": "İptal",
    "planning.delete_allocation": "Dağıtımı kaldır",
    "planning.submit": "Alıcı depo kuyruğuna gönder",
    "planning.submit_title": "Planlama alıcı depo kuyruğuna gönderilsin mi?",
    "planning.submit_body": "Yalnız bu tenant'ın işi gönderilir. Fiziksel palet hareket etmez.",
    "planning.submit_success": "Planlama alıcı depo kuyruğuna gönderildi.",
    "planning.submit_error": "Planlama gönderilemedi.",
    "planning.submit_blocked": "Göndermeden önce tüm adetleri dağıtın.",
    "planning.revision_open": "Düzeltme isteği",
    "planning.items_title": "Palet kalemleri (düzeltme)",
    "planning.items_hint": "Yanlış konulanı düzeltin: adedi değiştirin, ürünü silin ya da doğru ürünü ekleyin. Sonra dağıtımı düzeltip isteği çözüldü olarak işaretleyin.",
    "planning.item_search": "ASIN veya ürün adı ara",
    "planning.item_add": "Ekle",
    "planning.item_added": "Ürün eklendi.",
    "planning.item_remove": "Kalemi sil",
    "planning.item_removed": "Kalem silindi.",    "planning.revision_status.open": "Açık",
    "planning.revision_status.resolved": "Çözüldü",
    "planning.resolve_revision": "İsteği çözüldü olarak işaretle",
    "planning.revision_resolved": "Düzeltme isteği çözüldü.",
    "planning.revision_history": "Düzeltme geçmişi ({{count}})",
    "planning.no_revisions": "Düzeltme isteği yok.",
    "planning.quantity_updated": "Dağıtım güncellendi.",
    "planning.quantity_added": "Dağıtım eklendi.",
    "planning.quantity_removed": "Dağıtım kaldırıldı.",
    "planning.error": "Bir sorun oluştu. Lütfen yeniden deneyin.",
    "notification.many": "{{count}} yeni bildirim",
    "notification.open": "Aç",
    "notification.center": "Bildirimler",
    "notification.empty": "Henüz bildirim yok.",
    "notification.mark_all_read": "Tümünü okundu işaretle",
    "notification.type.unknown": "Yeni bir bildiriminiz var.",
    "notification.type.WORK_REVISION_REQUESTED": "Planlamanız için düzeltme istendi.",
    "notification.type.BOX_READY": "{{box_name}} koli etiketlemeye hazır.",
    "notification.type.RECEIVING_DISCREPANCY": "Kabul edilen palet beyanınızdan farklı. İnceleyip onaylayın.",
    "notification.type.DAMAGE_REPORTED": "Ürünleriniz kolilenirken hasar bildirildi. İnceleyip onaylayın.",
    "notification.type.BOX_OVER_PLAN": "Depo {{store_name}} için {{product_name}} ürününden {{boxed}} adet koliledi; planladığınız {{planned}} adedin {{over}} adet üstünde.",
    "notification.type.INBOUND_DAMAGED": "{{asin}} ürününden {{damaged}} adet gönderici depoya hasarlı geldi. Fotoğraflara bakıp görüldü olarak işaretleyin.",
    "notification.type.INBOUND_UNANNOUNCED": "Gönderici depo sizin için satırı olmayan {{quantity}} adet {{asin}} kaydetti.",
    "inb.tab.pallets": "Paletler",
    "inb.tab.inbound": "Gelen ürün",
    "inb.tab.stock": "Stok",
    "inb.filter.open": "Açık",
    "inb.filter.done": "Tamamlanan",
    "inb.filter.unknown": "Sahibi belirsiz",
    "inb.state.ORDERED": "Bekliyor",
    "inb.state.PARTIAL": "Kısmi geldi",
    "inb.state.COMPLETE": "Tamamlandı",
    "inb.state.CLOSED_SHORT": "Eksik kapandı",
    "inb.state.UNANNOUNCED": "Habersiz geldi",
    "inb.state.OWNER_UNKNOWN": "Sahibi belirsiz",
    "inb.empty.open": "Beklenen ürün yok.",
    "inb.empty.done": "Henüz tamamlanan satır yok.",
    "inb.empty.unknown": "Sahibi belirsiz ürün yok.",
    "inb.error": "Bir sorun oluştu. Lütfen tekrar deneyin.",
    "inb.no_warehouse": "Size bağlı bir gönderici depo henüz yok.",
    "inb.add": "Satır ekle",
    "inb.import_hint": "ASIN, QTY, ORDER_ID kolonlu Excel veya CSV. Satırlar seçili depoya eklenir.",
    "inb.import_duplicates": "{{count}} satır atlandı: bu ASIN ve sipariş no zaten var",
    "inb.import_duplicates_hint": "Aynı dosyayı tekrar yüklemek satırları ikinci kez eklemez.",
    "inb.add_hint": "Amazon siparişini depoya bildir. Ürün gelince depo teslim alır.",
    "inb.edit_quantity": "Sipariş adedini değiştir",
    "inb.product_approved": "Ürün (sadece onaylı ürünler)",
    "inb.unknown_product": "Adı bilinmiyor",
    "inb.order_id": "Order ID",
    "inb.order_id_optional": "Order ID (biliniyorsa)",
    "inb.ordered": "Sipariş",
    "inb.received": "Gelen",
    "inb.remaining": "Bekleyen",
    "inb.receive": "Teslim al",
    "inb.receive_summary": "Sipariş {{ordered}} · Daha önce gelen {{received}} · Bekleyen {{remaining}}",
    "inb.received_now": "Gelen adet",
    "inb.damaged_toggle": "Hasarlı var",
    "inb.damaged_of_total": "Bunlardan kaçı hasarlı?",
    "inb.damage_note_placeholder": "ör. kutu ezik, 2 kablo kopuk",
    "inb.photos": "Fotoğraf (en fazla 5)",
    "inb.photo_remove": "Fotoğrafı çıkar",
    "inb.photos_failed": "Kaydedildi ama bir fotoğraf yüklenemedi. Teslimatlar listesinden tekrar ekleyin.",
    "inb.preview": "{{count}} geldi",
    "inb.preview_split": "{{count}} geldi ({{good}} sağlam, {{damaged}} hasarlı)",
    "inb.preview_left": "{{count}} adet daha bekleniyor",
    "inb.preview_complete": "hepsi geldi, satır tamamlanır",
    "inb.preview_over": "siparişten {{count}} fazla, yine de kaydedilir",
    "inb.quantity_required": "1 veya daha büyük tam sayı girin.",
    "inb.damaged_required": "Hasarlı adedi girin (veya tiki kaldırın).",
    "inb.damaged_too_many": "Hasarlı adet, gelen adetten fazla olamaz.",
    "inb.asin_required": "ASIN girin.",
    "inb.order_id_required": "Amazon Order ID girin.",
    "inb.tenant_required": "Tenant seçin veya \"Sahibi belirsiz\"i tikleyin.",
    "inb.unannounced": "Habersiz gelen ürün",
    "inb.unannounced_hint": "Satırı olmayan ürün geldi. Sahibini paketteki adres veya şirket bilgisinden seçin.",
    "inb.unannounced_note_placeholder": "ör. koli etiketi, kargo no",
    "inb.select_tenant": "Tenant seçin",
    "inb.owner_unknown": "Sahibi belirsiz",
    "inb.owner_unknown_hint": "Kimsenin stoğuna girmez. Koli etiketinin fotoğrafı sahibini bulmayı kolaylaştırır.",
    "inb.not_in_list_hint": "Bu tenant'ın ürün listesinde yok. Yine de kaydedilir, tenant'a bildirim gider.",
    "inb.not_in_list": "Ürün listesinde yok",
    "inb.not_in_list_title": "Tenant ürünü listesine eklemeden palete konamaz",
    "inb.assign": "Sahiplendir",
    "inb.assigned": "Sahip atandı.",
    "inb.close_short": "Eksik kapat",
    "inb.close_short_body": "{{count}} adet artık beklenmiyor. Satır Tamamlanan listesine geçer, \"Yolda\"dan düşer.",
    "inb.closed": "Satır eksik kapatıldı.",
    "inb.deleted": "Satır silindi.",
    "inb.added": "Satır eklendi. Depo artık bu ürünü bekliyor.",
    "inb.updated": "Sipariş adedi değişti.",
    "inb.saved": "Kaydedildi.",
    "inb.saved_damaged": "Kaydedildi. Tenant'a hasar bildirildi.",
    "inb.receipts": "Teslimatlar",
    "inb.receipts_count": "Teslimatlar ({{count}})",
    "inb.units": "{{count}} adet",
    "inb.damaged": "Hasarlı",
    "inb.damaged_count": "{{count}} hasarlı",
    "inb.seen": "görüldü",
    "inb.acknowledge": "Gördüm",
    "inb.acknowledged": "Hasar görüldü olarak işaretlendi.",
    "inb.on_hand": "Depoda",
    "inb.on_pallet": "Palette",
    "inb.on_shelf": "Rafta",
    "inb.on_the_way": "Yolda",
    "inb.stock_legend": "Depoda = sağlam teslim alınan − gönderilen paletler. Palette = henüz gönderilmemiş paletlerde. Rafta = rafta bekleyen, yeni bir palete eklenebilir. Hasarlı ürün hiçbir zaman Rafta'ya girmez.",
    "inb.stock_empty": "Henüz stok yok. Stok bu depodaki ilk gelen ürün satırınızla başlar.",
    "inb.stock_search": "ASIN veya ürün adına göre ara...",
    "inb.inbound_search": "ASIN, ürün adı veya sipariş no ile ara...",
    "inb.search_no_match": "Aramaya veya filtreye uyan kayıt yok.",
    "inb.group_by_order": "Siparişe göre grupla",
    "inb.no_order_id": "Sipariş no yok",
    "inb.group_summary": "{{count}} satır · {{remaining}} adet bekleniyor",
    "notification.type.ROUTE_PROFILE_CREATED": "{{code}} rota profili oluşturuldu.",
    "notification.type.ROUTE_PROFILE_UPDATED": "{{code}} rota profili güncellendi (sürüm {{version}}).",
    "notification.type.ROUTE_PROFILE_ACTIVATED": "{{code}} rota profili etkinleştirildi.",
    "notification.type.ROUTE_PROFILE_DEACTIVATED": "{{code}} rota profili devre dışı bırakıldı.",
    "notification.type.PALLET_READY": "{{pallet_name}} paleti hazır. Planlamaya başlayabilirsiniz.",
    "notification.type.PALLET_SHIPPED": "{{pallet_name}} paleti hedef depoya sevk edildi.",
    "notification.type.PALLET_INCOMING": "{{pallet_name}} paleti deponuza doğru yolda.",
    "notification.type.PLANNING_SUBMITTED": "{{tenant_name}}, {{pallet_name}} paleti için planını gönderdi.",
    "notification.type.PALLET_RECEIVED": "{{pallet_name}} paleti hedef depoda kabul edildi. Adetler beyanınızla uyuşuyor.",
    "notification.type.REVISION_RESOLVED": "{{tenant_name}}, {{pallet_name}} paletindeki düzeltme isteğinizi çözdü.",
    "uk.create_box": "Koli Oluştur",
    "uk.box_name": "Koli Adı",
    "uk.weight": "Ağırlık (kg)",
    "uk.dimensions": "Boyutlar (cm)",
    "uk.length": "Uzunluk",
    "uk.width": "Genişlik",
    "uk.height": "Yükseklik",
    "uk.transfer_to_fba": "FBA Ekibine Transfer Et",
    "uk.add_item_to_box": "Koliye Ürün Ekle",
    "uk.boxed": "Kolilendi",
    "uk.planned": "Planlanan",
    "recv.warehouse": "Depo",
    "recv.no_assignment": "Hiçbir depoda alıcı depo personeli olarak atanmadınız. Bir yöneticiden atama isteyin.",
    "recv.empty_active": "Yolda olan veya kolileme bekleyen palet yok.",
    "recv.empty_history": "Kolilemesi tamamlanan paletler burada görünür.",
    "recv.loading_error": "Paletler yüklenemedi.",
    "recv.error": "Bir sorun oluştu. Lütfen yeniden deneyin.",
    "recv.receive_pallet": "Paleti kabul et",
    "recv.receive_title": "Palet kabul edilsin mi?",
    "recv.receive_body": "Paletin tamamının bu depoya ulaştığını onaylayın. Bu, palet üzerindeki tüm tenant işleri için geçerlidir.",
    "recv.received": "Palet kabul edildi.",
    "recv.received_diff": "Palet kabul edildi. Tenant'lar için {{count}} fark kaydedildi.",
    "recv.count_title": "Paleti say ve kabul et",
    "recv.count_body": "Aşağıdaki adetleri kontrol edin. Alanlar beyan edilen adetlerle dolu gelir; yalnızca farklı olanı değiştirin.",
    "recv.count_load_error": "Palet kalemleri yüklenemedi.",
    "recv.count_all_match": "Hepsi eşleşiyor",
    "recv.count_add_unexpected": "Beyan dışı ürün ekle",
    "recv.count_unexpected": "Beyan dışı ürünler",
    "recv.count_tenant": "Tenant",
    "recv.count_product": "Ürün (ASIN veya ad)",
    "recv.count_no_product": "Katalogda eşleşen ürün yok",
    "recv.count_remove": "Kaldır",
    "recv.count_short": "{{count}} eksik",
    "recv.count_over": "{{count}} fazla",
    "recv.discrepancies_count": "Kabul farkları · {{count}} üründe",
    "recv.discrepancy_waiting": "Tenant'ın onayı bekleniyor.",
    "recv.damage_report": "Hasar bildir",
    "recv.damage_title": "Hasarlı ürünleri bildir",
    "recv.damage_body": "Kolileme sırasında hasarlı çıkan adetler. Tenant'ın onaylayıp planı düzeltmesi gerekir.",
    "recv.damage_item": "Ürün",
    "recv.damage_good_left": "{{count}} sağlam",
    "recv.damage_qty": "Hasarlı adet",
    "recv.damage_reported": "Hasar bildirildi.",
    "recv.photo_add": "Fotoğraf ekle",
    "recv.photo_added": "Fotoğraf eklendi.",
    "recv.photo_error": "Fotoğraf eklenemedi.",
    "disc.declared": "Beyan",
    "disc.good": "Sağlam",
    "disc.damaged": "Hasarlı",
    "disc.missing": "Eksik",
    "disc.extra": "Fazla",
    "disc.type.SHORT": "Eksik",
    "disc.type.DAMAGED": "Hasarlı",
    "disc.type.OVER": "Fazla",
    "disc.type.UNEXPECTED": "Beyan dışı",
    "disc.type.BOXING_DAMAGE": "Kolilemede hasar",
    "disc.status.OPEN": "Açık",
    "disc.status.ACKNOWLEDGED": "Onaylandı",
    "disc.accepted": "Kabul edilen fazla: {{count}}",
    "disc.photos": "Fotoğraflar",
    "planning.discrepancy_open": "Onaylanacak farklar",
    "planning.discrepancy_title": "Sayılan palet beyanınızdan farklı",
    "planning.discrepancy_body": "Planlama kullanılabilir adedi esas alır. Farkları onaylayın, dağıtımı düzeltin ve yeniden gönderin.",
    "planning.accept_extra": "Fazla adedi kabul et (en çok {{max}})",
    "planning.acknowledge": "Farkları onayla",
    "planning.acknowledged": "Farklar onaylandı.",
    "planning.proportional": "Orantılı azalt",
    "planning.proportional_hint": "Öneri: her mağaza dağıtımını kullanılabilir adede göre orantılı düşürür.",
    "planning.proportional_done": "Dağıtım azaltıldı.",
    "planning.preliminary": "Ön plan: palet varış deposunda sayıldıktan sonra değişebilir.",
    "planning.counted": "Beyan {{declared}} · sağlam {{good}} · hasarlı {{damaged}}",
    "planning.correction_mode": "Kolileme sürüyor. Dağıtımları yalnızca kullanılabilir adede kadar ve kolilenen adedin altına inmeden azaltabilirsiniz.",
    "recv.receive_first": "Kolileme başlamadan önce paleti kabul edin.",
    "recv.planning_pending": "Tenant henüz planını göndermedi. Tenant'ın dağıttığı satırları koliyleyebilirsiniz, ama kolilemeyi bitirmek için plan gönderilmiş olmalı.",
    "recv.read_only": "Kolileme tamamlandı. Bu iş salt okunurdur.",
    "labels.files_title": "Etiket dosyaları",
    "labels.state.NONE": "Etiket henüz yok",
    "labels.state.READY": "Etiket hazır",
    "labels.state.APPLIED": "Tamam",
    "labels.mark_done": "Etiket tamam",
    "labels.done": "Tamam",
    "labels.undo_applied": "Geri al",
    "labels.complete_title": "Bu iş tamamlansın mı?",
    "labels.complete_body": "Bu, açık kalan son etiket dosyası. Onaylarsan iş tamamlanır, tenant'a bildirim gider ve bu ekrandan geri alınamaz.",
    "labels.complete_confirm": "Evet, tamamla",
    "labels.waiting": "Etiketi tamamlanacak {{count}} koli",
    "labels.popup_blocked": "Tarayıcı yazdırma sekmelerini engelledi. Bu site için açılır pencerelere izin verip tekrar deneyin.",
    "labels.applied_msg": "Koli etiketlendi olarak işaretlendi",
    "labels.unapplied_msg": "Koli etiketlenmedi olarak işaretlendi",
    "labels.completed_msg": "Tüm koliler etiketlendi. Bu iş tamamlandı.",
    "mkt.empty_title": "Etiket bekleyen koli yok",
    "mkt.empty_hint": "Alıcı depo koliyi hazır işaretleyince burada görünür.",
    "mkt.card_ready": "{{count}} kolinin {{ready}} tanesi hazır",
    "mkt.card_progress": "{{labelled}}/{{count}} koli etiketli",
    "mkt.waiting_banner": "Hazır her koli için FBA ve shipment etiketlerini yükleyin. Alıcı depo etiketleri yazdırıp yapıştırır.",
    "mkt.completed_banner": "Tüm koliler etiketlendi. Bu iş tamamlandı.",
    "mkt.no_boxes": "Henüz hazır koli yok",
    "mkt.upload_for_store": "{{store}} için etiket yükle",
    "mkt.upload_hint": "PDF, PNG veya JPG. Tek dosya birden fazla koliyi kapsayabilir.",
    "mkt.drop_here": "Etiketi buraya bırakın",
    "mkt.assign_title": "Etiketi kolilere ata",
    "mkt.assign_body": "{{file}} hangi kolileri kapsıyor?",
    "mkt.select_all": "Tümünü seç ({{count}})",
    "mkt.assign_save": "{{count}} koliye ata",
    "mkt.already_labeled": "Zaten etiketi var",
    "mkt.assigned": "Etiket {{count}} koliye atandı",
    "mkt.label_removed": "Etiket silindi",
    "mkt.contents": "İçerik",
    "mkt.labels": "Etiketler",
    "mkt.applied_lock": "Depo bu etiketleri yapıştırdı, artık silinemez.",
    "status.COMPLETED": "Tamamlandı",
    "us.work.COMPLETED": "Tamamlandı",
    "notification.type.LABELS_READY": "{{tenant_name}} {{count}} koli için etiket yükledi. Yazdırmaya hazır.",
    "notification.type.WORK_COMPLETED": "Tüm koliler etiketlendi. İş tamamlandı.",
    "notification.type.DB_BACKUP_FAILED": "Otomatik veritabanı yedeği alınamadı: {{error}}",
    "notification.type.FILE_BACKUP_FAILED": "Otomatik dosya yedeği alınamadı: {{error}}",
    "maintenance.toast": "Sistem bakım modunda. Değişiklikler şu an kaydedilemiyor; biraz sonra tekrar deneyin.",
    "maintenance.banner": "Sistem bakım modunda. Değişiklikler kaydedilemiyor. Lütfen bir işlem yapmadan önce bekleyin; bakım bitince bu uyarı kendiliğinden kaybolur.",
    "maintenance.banner_platform": "BAKIM MODU AÇIK. Diğer herkesin kaydetmesi kilitli; veriyi yalnızca siz, platform yöneticisi, değiştirebilirsiniz. İşiniz bitince DB Yedek sekmesinden kapatın.",
    "adm.db.maint_title": "Bakım modu",
    "adm.settings.saved": "Ayar kaydedildi",
    "adm.settings.over_stock": "Rafta stoktan fazlasını palete eklemeye izin ver",
    "adm.settings.over_stock_on": "Açık: sender, rafta görünen stoktan fazlasını palete koyabilir; uyarı görür.",
    "adm.settings.over_stock_off": "Kapalı: sender, rafta görünen stoktan fazlasını palete koyamaz.",
    "adm.db.maint_on": "AÇIK: veriyi sadece platform yöneticisi değiştirebilir. Diğer herkes sadece görüntüleyebilir. Siz kapatana kadar açık kalır.",
    "adm.db.maint_off": "Kapalı. Restore'dan önce açın, böylece bu sırada kimse veritabanına yazmaz.",
    "adm.db.maint_turn_on": "Aç",
    "adm.db.maint_turn_off": "Kapat",
    "adm.db.maint_turned_on": "Bakım modu açıldı",
    "adm.db.maint_turned_off": "Bakım modu kapatıldı",
    "adm.db.export_title": "Yedek indir",
    "adm.db.export_intro": "Tüm veritabanını zip olarak indirir, şifrenizle şifrelenir (AES-256). 7-Zip ile açın. Yüklenen dosyalar (etiketler, fotoğraflar) içinde yoktur.",
    "adm.db.your_password": "Şifreniz",
    "adm.db.export": "Yedeği indir",
    "adm.db.exported": "Yedek indirildi",
    "adm.db.restore_title": "Zip'ten geri yükle",
    "adm.db.restore_intro": "TÜM veritabanını zip ile değiştirir: kendi yedeğimiz ya da Mongo Viewer dökümü. Adımlar: bakım modunu açın, önizleyin, sayıları kontrol edin, değiştirin. Önce mevcut veritabanının güvenlik kopyası yedek bucket'ına yazılır.",
    "adm.db.zip_file": "Zip dosyası",
    "adm.db.zip_password": "Zip şifresi",
    "adm.db.zip_password_hint": "sadece şifreli zip için",
    "adm.db.preview": "Önizle",
    "adm.db.collection": "Koleksiyon",
    "adm.db.now": "Şu an",
    "adm.db.after": "Restore sonrası",
    "adm.db.emptied_note": "Kırmızı satırlar boşaltılacak: zip'te bunlar için veri yok.",
    "adm.db.no_tools_user": "Zip'te platform yöneticisi hesabı yok. Geri yüklenirse sisteme giremezsiniz, bu yüzden reddedilir.",
    "adm.db.needs_maintenance": "Önce bakım modunu açın.",
    "adm.db.needs_bucket": "Yedek bucket'ı ayarlı değil (R2_BACKUP_* ve BACKUP_ZIP_PASSWORD). Otomatik yedek ve restore için gerekli.",
    "adm.db.replace": "Veritabanını değiştir",
    "adm.db.confirm_title": "Tüm veritabanı değiştirilsin mi?",
    "adm.db.confirm_body": "Mevcut tüm veri zip'teki ile değiştirilir. Önce güvenlik kopyası alınır. Sonra bakım modu açık kalır: veriyi kontrol edip kapatın. Tekrar giriş yapmanız gerekebilir.",
    "adm.db.restored": "{{n}} kayıt geri yüklendi. Güvenlik kopyası: {{key}}. Bakım modu hâlâ açık.",
    "adm.db.auto_title": "Otomatik yedekler",
    "adm.db.auto_intro": "Her kural R2 yedek bucket'ına şifreli bir yedek yazar (şifre: BACKUP_ZIP_PASSWORD) ve sadece en yeni N dosyasını tutar. Sunucu kapalıyken kaçan yedek, açılınca bir kez alınır. Bakım modunda hiçbir şey çalışmaz.",
    "adm.db.backup_now": "Şimdi yedek al",
    "adm.db.saved": "Yedek bucket'a yazıldı",
    "adm.db.add_rule": "Kural ekle",
    "adm.db.edit_rule": "Kuralı düzenle",
    "adm.db.no_rules": "Henüz otomatik yedek yok.",
    "adm.db.rule_daily": "Her gün {{time}}",
    "adm.db.rule_days": "{{n}} günde bir, {{time}}",
    "adm.db.rule_weeks": "{{n}} haftada bir, {{day}} {{time}}",
    "adm.db.rule_months": "{{n}} ayda bir, ayın {{day}}. günü {{time}}",
    "adm.db.rule_invalid": "Değerleri kontrol edin: sıklık 1–31 gün / 1–54 hafta / 1–12 ay, gün 1–28, saklama 1–365.",
    "adm.db.keep_n": "son {{n}} tanesi saklanır",
    "adm.db.last_run": "Son çalışma",
    "adm.db.next_run": "Sonraki",
    "adm.db.timezone": "Saatler İngiltere saatidir (Europe/London).",
    "adm.fb.title": "Dosya yedekleri",
    "adm.fb.intro": "Yüklenen dosyaların (etiketler ve fotoğraflar) yedek bucket'taki kopyaları. Her çalıştırmada yalnızca henüz orada olmayan dosyalar kopyalanır ve kopyalar süresiz saklanır. Uygulamada silinen dosya hemen gizlenir; bir sonraki çalıştırma onu kopyalar, ana bucket'tan siler ve kopyasını kuraldaki gün sayısı kadar saklar. Burada geri yükleme yok: dosyaları elle geri kopyalayın.",
    "adm.fb.add_rule": "Dosya yedek kuralı ekle",
    "adm.fb.edit_rule": "Dosya yedek kuralını düzenle",
    "adm.fb.run_now": "Şimdi çalıştır",
    "adm.fb.ran": "Dosya yedeği tamamlandı",
    "adm.fb.keep_deleted": "Silinen dosyaların kopyasını sakla (gün)",
    "adm.fb.keep_deleted_n": "silinen dosyalar {{n}} gün saklanır",
    "adm.fb.result": "{{copied}} kopyalandı, {{pruned}} yedekten silindi",
    "adm.db.unit": "Tekrar",
    "adm.db.unit_day": "Günlük",
    "adm.db.unit_week": "Haftalık",
    "adm.db.unit_month": "Aylık",
    "adm.db.every_day": "Kaç günde bir (1–31)",
    "adm.db.every_week": "Kaç haftada bir (1–54)",
    "adm.db.every_month": "Kaç ayda bir (1–12)",
    "adm.db.weekday": "Gün",
    "adm.db.month_day": "Ayın günü (1–28)",
    "adm.db.time": "Saat",
    "adm.db.keep": "Son kaç dosya saklansın",
    "adm.db.wd.0": "Pazartesi",
    "adm.db.wd.1": "Salı",
    "adm.db.wd.2": "Çarşamba",
    "adm.db.wd.3": "Perşembe",
    "adm.db.wd.4": "Cuma",
    "adm.db.wd.5": "Cumartesi",
    "adm.db.wd.6": "Pazar",
    "adm.db.files_title": "Bucket'taki son 20 yedek",
    "adm.db.no_files": "Bucket'ta henüz yedek yok.",
    "adm.db.download": "İndir",
    "adm.db.kind_auto": "Otomatik (silinmiş kural)",
    "adm.db.kind_now": "Şimdi yedek al",
    "adm.db.kind_pre": "Restore öncesi güvenlik kopyası",
    "adm.db.files_note": "Buradaki dosyalar BACKUP_ZIP_PASSWORD ile şifrelidir. Geri yüklemek için indirin ve \"Zip'ten geri yükle\" bölümünde bu şifreyle kullanın.",
    "recv.revision_open": "Açık düzeltme isteği",
    "recv.items_units": "{{count}} ürün çeşidi · {{units}} adet",
    "recv.boxes_ready": "{{ready}}/{{count}} koli hazır",
    "recv.box_count": "{{count}} koli",
    "recv.item_types": "{{count}} çeşit",
    "recv.add_box": "Koli ekle",
    "recv.boxes_title": "Koliler",
    "recv.store_no_boxes": "Bu mağaza için henüz koli yok",
    "recv.store_no_boxes_hint": "Ürünleri koliye koymak için ilk kolinizi açın.",
    "recv.store_all_boxed": "Tamamı kolilendi",
    "recv.store_summary": "{{boxes}} koli · {{ready}} hazır · {{boxed}}/{{planned}} adet kolilendi",
    "recv.store_summary_labels": "{{boxes}} koli · {{labelled}} etiketli · {{applied}} tamam",
    "mkt.pages_mismatch": "Bu dosyada {{pages}} sayfa var ama {{count}} koli seçili. {{count}} veya {{double}} sayfa beklenir (sadece etiket ya da etiket + kargo etiketi). Dosyayı ve kolileri kontrol et.",
    "recv.store_plan": "Mağaza planı",
    "recv.plan_summary": "{{types}} çeşit · {{boxed}}/{{planned}} adet",
    "recv.dims_set": "Ölçü girildi",
    "recv.sum_units": "{{boxed}} / {{planned}} adet ürün kolilendi",
    "recv.sum_boxes_opened": "koli açıldı",
    "recv.sum_boxes_ready": "koli hazır",
    "recv.sum_labelled": "{{applied}} / {{count}} koli etiketlendi",
    "recv.band_show": "Detayı göster",
    "recv.band_hide": "Gizle",
    "product.show_image": "Ürün resmini göster",
    "product.image_missing": "Bu ürün için resim bulunamadı.",
    "recv.left": "{{count}} kaldı",
    "recv.box_ready": "Hazır",
    "recv.box_locked": "Bu koli hazır işaretli ve kilitli. Değiştirmek için önce yeniden açın.",
    "recv.mark_ready": "Koliyi hazır işaretle",
    "recv.reopen_box": "Koliyi yeniden aç",
    "recv.box_marked_ready": "Koli hazır işaretlendi.",
    "recv.box_reopened": "Koli yeniden açıldı.",
    "recv.set_dims": "Ölçü gir",
    "recv.dims_needed": "Ölçü gerekli",
    "recv.dims_required": "Koliyi hazır işaretlemeden önce ağırlık ve ölçüler girilmelidir.",
    "recv.dims_title": "Koli ağırlığı ve ölçüleri",
    "recv.dims_saved": "Koli ölçüleri kaydedildi.",
    "recv.box_size": "Koli boyutu",
    "recv.custom_size": "Özel boyut",
    "recv.dims_range": "Ağırlık ve ölçüler 0'dan büyük, en fazla 100 olmalı.",
    "recv.select_store": "Mağaza seçin...",
    "recv.no_store_left": "Tüm mağazaların bütün ürünleri zaten kolilendi.",
    "recv.box_name_placeholder": "Boşsa otomatik oluşturulur",
    "recv.box_created": "Koli oluşturuldu.",
    "recv.box_deleted": "Koli silindi.",
    "recv.delete_box": "Koliyi sil",
    "recv.delete_box_body": "Bu koli içindeki tüm ürünler mağaza planına geri döner. Bu işlem geri alınamaz.",
    "recv.box_items": "Koli ürünleri ({{count}})",
    "recv.box_empty": "Bu kolide henüz ürün yok.",
    "recv.add_item": "Ürün ekle",
    "recv.item_added": "Ürün koliye eklendi.",
    "recv.item_removed": "Ürün kaldırıldı.",
    "recv.search_placeholder": "ASIN, FNSKU veya ürün adına göre ara...",
    "recv.max": "en çok {{count}}",
    "recv.over_title": "Plandan fazla",
    "recv.over_body": "{{name}}: plan {{planned}}, bu işlemle {{boxed}} olur (plandan +{{count}} fazla). Tenant bilgilendirilecek. Bir neden seçin.",
    "recv.over_reason": "Neden",
    "recv.over_r.EXTRA_ON_PALLET": "Palette daha fazla ürün çıktı",
    "recv.over_r.COUNT_DIFF": "Sayım farkı",
    "recv.over_r.OTHER": "Diğer (not gerekli)",
    "recv.over_note": "Not",
    "recv.over_confirm": "Fazlayı koliye ekle",
    "recv.over_badge": "plandan +{{count}}",
    "planning.over_note": "Depo planladığınızdan {{count}} adet fazla koliledi.",
    "recv.set_max": "Kalan en yüksek miktarı kullan ({{count}})",
    "recv.complete_boxing": "Kolilemeyi tamamla",
    "recv.complete_title": "{{tenant}} için kolileme tamamlansın mı?",
    "recv.complete_body": "Tüm koliler hazır ve plana uygun. Tenant'ın marketplace aşaması başlayabilir.",
    "recv.boxing_completed": "Kolileme tamamlandı.",
    "recv.request_correction": "Düzeltme iste",
    "recv.correction_open": "Düzeltme istendi",
    "recv.correction_title": "Düzeltme iste",
    "recv.correction_body": "Tenant neyin düzeltileceğini görür. İstek çözülene kadar kolileme tamamlanamaz.",
    "recv.correction_sent": "Düzeltme isteği gönderildi.",
    "recv.return_planning": "Planlamaya geri gönder",
    "recv.return_title": "İş Planlama'ya geri gönderilsin mi?",
    "recv.return_body": "Tenant planını değiştirmek zorunda kalır. Mevcut koliler kalır. Neyin değişmesi gerektiğini yazın.",
    "recv.returned": "İş Planlama'ya geri gönderildi.",
    "recv.note_placeholder": "Sorunu açıklayın...",
    "recv.send": "Gönder",
    "recv.print_all_fnsku": "Tüm FNSKU'ları yazdır",
    "recv.print_fnsku": "FNSKU yazdır",
    "recv.print_fnsku_for": "{{name}} için FNSKU yazdır",
    "recv.print_quantity": "{{name}} için yazdırma adedi",
    "recv.print_decrease": "{{name}} için yazdırma adedini azalt",
    "recv.print_increase": "{{name}} için yazdırma adedini artır",
    "recv.fnsku_missing": "FNSKU yok",
    "recv.no_fnsku": "FNSKU mevcut değil",
    "recv.no_printable": "Bu mağaza için yazdırılabilir FNSKU etiketi yok.",
    "recv.nothing_to_print": "Yazdırılacak kalan adet yok.",
    "recv.printing": "{{count}} FNSKU etiketi yazdırılıyor",
    "recv.printed_skipped": "{{count}} etiket yazdırıldı. FNSKU'su olmayan {{skipped}} ürün atlandı.",
    "recv.print_failed": "FNSKU etiketleri yazdırılamadı. Tarayıcının yazdırma ayarlarını kontrol edip yeniden deneyin.",
    "fba.upload_label": "Etiket Yükle",
    "fba.fba_label": "FBA Etiketi",
    "fba.shipping_label": "Kargo Etiketi",
    "fba.complete": "Tamamlandı Olarak İşaretle",
    "fba.labels_required": "Her koli için min. 2 etiket gerekli",
    "admin.users": "Kullanıcılar",
    "admin.products": "Ürünler",
    "admin.stores": "Mağazalar",
    "admin.store_fnsku": "Mağaza FNSKU",
    "admin.create_user": "Kullanıcı Oluştur",
    "adm.us.create_staff": "Depo Personeli Ekle",
    "admin.import_products": "Ürün İçe Aktar",
    "admin.import_fnsku": "FNSKU İçe Aktar",
    "admin.role": "Rol",
    "admin.email": "E-posta",
    "admin.password": "Şifre",
    "admin.category": "Kategori",
    "admin.ean": "EAN",
  }
};
